/**
 * French catalog. It defines the set of message keys: every other locale must provide exactly
 * these keys (enforced by the type checker and by tests). Messages use ICU MessageFormat.
 */
export const fr = {
    'brand.name': 'beinstore',
    // --- emails ---
    'email.footer.automated': 'Cet e-mail a été envoyé automatiquement par {brand}. Merci de ne pas y répondre.',
    'email.signInCode.subject': 'Votre code de connexion {brand} : {code}',
    'email.signInCode.heading': 'Votre code de connexion',
    'email.signInCode.intro': 'Utilisez ce code pour vous connecter à {brand} :',
    'email.signInCode.expiry': 'Il expire dans {minutes, plural, one {# minute} other {# minutes}} et ne peut être utilisé qu’une seule fois.',
    'email.signInCode.ignore': 'Si vous n’êtes pas à l’origine de cette demande, ignorez cet e-mail : personne ne peut se connecter sans ce code.',
    'email.signInCode.neverShare': 'L’équipe {brand} ne vous demandera jamais ce code.',
    'email.order.subject': 'Commande n° {number} confirmée – {store}',
    'email.order.heading': 'Merci pour votre commande',
    'email.order.intro': '{store} a bien reçu votre commande n° {number} :',
    'email.order.line': '{quantity} × {title} : {amount}',
    'email.order.cashOnDelivery': 'Paiement à la livraison : préparez le montant total.',
    'email.order.bankTransfer': 'Paiement par virement bancaire : {instructions}',
    'email.order.shipping': 'Livraison à : {address}',
    'email.order.pickup': 'Retrait en magasin : la boutique vous contactera quand la commande sera prête.',
    'email.newOrder.subject': 'Nouvelle commande n° {number} ({total})',
    'email.newOrder.heading': 'Nouvelle commande',
    'email.newOrder.intro': '{customer} a passé la commande n° {number} de {total} sur {store}.',
    'email.newOrder.action': 'Voir la commande',
    // --- admin: common ---
    'admin.language': 'Langue',
    'admin.language.ar': 'العربية',
    'admin.language.aeb': 'تونسي',
    'admin.language.fr': 'Français',
    'admin.language.en': 'English',
    'admin.nav.home': 'Accueil',
    'admin.nav.account': 'Mon compte',
    'admin.nav.security': 'Sécurité',
    'admin.nav.signOut': 'Se déconnecter',
    'admin.nav.label': 'Navigation principale',
    'admin.nav.skip': 'Aller au contenu',
    'admin.nav.viewStore': 'Voir la boutique',
    'admin.nav.store': 'Navigation de la boutique',
    'admin.nav.menu': 'Ouvrir le menu',
    'admin.nav.closeMenu': 'Fermer le menu',
    'admin.nav.storeHome': 'Vue d’ensemble',
    'admin.nav.group.sales': 'Ventes',
    'admin.nav.group.catalog': 'Catalogue',
    'admin.nav.group.online': 'Boutique en ligne',
    'admin.nav.group.fulfilment': 'Livraison et encaissement',
    'admin.nav.group.settings': 'Paramètres',
    'admin.auth.tagline': 'Gérez votre boutique en ligne, de la commande à l’encaissement.',
    'admin.auth.point.orders': 'Commandes, livraisons et paiement à la livraison au même endroit',
    'admin.auth.point.languages': 'Boutique en arabe, en français, en tunisien et en anglais',
    'admin.auth.point.secure': 'Connexion par code e-mail, vérification en deux étapes en option',
    'admin.loading': 'Chargement…',
    'admin.save': 'Enregistrer',
    'admin.saved': 'Modifications enregistrées.',
    'admin.copy': 'Copier',
    'admin.copied': 'Copié',
    'admin.download': 'Télécharger',
    'admin.loadMore': 'Afficher plus',
    'storefront.reviews.title': 'Avis clients',
    'storefront.reviews.storeTitle': 'Avis sur la boutique',
    'storefront.reviews.count': '{count, plural, one {# avis} other {# avis}}',
    'storefront.reviews.average': '{average} sur 5',
    'storefront.reviews.stars': '{rating} étoiles sur 5',
    'storefront.reviews.bar': '{stars} étoiles : {count}',
    'storefront.reviews.empty': 'Pas encore d’avis.',
    'storefront.reviews.verified': 'Achat vérifié',
    'storefront.reviews.anonymous': 'Client vérifié',
    'storefront.reviews.reply': 'Réponse de la boutique',
    'storefront.reviews.pages': 'Pages des avis',
    'storefront.review.title': 'Donnez votre avis',
    'storefront.review.intro': 'Votre avis est publié après validation par la boutique.',
    'storefront.review.store': 'La boutique (accueil, livraison…)',
    'storefront.review.rating': 'Votre note',
    'storefront.review.star': '{count, plural, one {# étoile} other {# étoiles}}',
    'storefront.review.comment': 'Votre commentaire (facultatif)',
    'storefront.review.name': 'Votre prénom (affiché avec l’avis)',
    'storefront.review.submit': 'Envoyer mon avis',
    'storefront.review.sent': 'Merci ! Votre avis sera publié après validation.',
    'storefront.review.done': 'Avis envoyé',
    'storefront.review.error.already-reviewed': 'Vous avez déjà donné votre avis.',
    'storefront.review.error.review-not-open': 'Vous pourrez donner votre avis une fois la commande livrée.',
    'storefront.review.error.generic': 'Votre avis n’a pas pu être envoyé. Vérifiez les champs et réessayez.',
    'storefront.comment.link': 'Laisser un commentaire',
    'storefront.comment.title': 'Un commentaire pour la boutique',
    'storefront.comment.intro': 'Une idée, une remarque ? Votre message est envoyé à la boutique et n’est pas publié.',
    'storefront.comment.message': 'Votre message',
    'storefront.comment.send': 'Envoyer',
    'storefront.comment.sent': 'Merci, votre message a été envoyé à la boutique.',
    'storefront.comment.error': 'Le message n’a pas pu être envoyé. Réessayez plus tard.',
    'admin.reviews.title': 'Avis clients',
    'admin.reviews.empty': 'Aucun avis pour le moment.',
    'admin.reviews.search': 'Rechercher (texte ou prénom)',
    'admin.reviews.subject': 'Sur',
    'admin.reviews.subject.product': 'Produit',
    'admin.reviews.subject.store': 'Boutique',
    'admin.reviews.rating': 'Note',
    'admin.reviews.stars': '{rating}/5',
    'admin.reviews.status': 'Statut',
    'admin.reviews.status.pending': 'À valider',
    'admin.reviews.status.approved': 'Publié',
    'admin.reviews.status.hidden': 'Masqué',
    'admin.reviews.filter.allStatuses': 'Tous les statuts',
    'admin.reviews.filter.allSubjects': 'Produits et boutique',
    'admin.reviews.filter.allRatings': 'Toutes les notes',
    'admin.reviews.column.date': 'Date',
    'admin.reviews.column.review': 'Avis',
    'admin.reviews.column.author': 'Client',
    'admin.reviews.order': 'Commande n° {number}',
    'admin.reviews.open': 'Ouvrir l’avis du {date}',
    'admin.reviews.anonymous': 'Client (données effacées)',
    'admin.reviews.noComment': 'Sans commentaire',
    'admin.reviews.approve': 'Publier',
    'admin.reviews.hide': 'Masquer',
    'admin.reviews.reply': 'Réponse publique',
    'admin.reviews.replyLabel': 'Votre réponse',
    'admin.reviews.replyHint': 'Affichée sous l’avis sur la boutique en ligne.',
    'admin.reviews.saveReply': 'Enregistrer la réponse',
    'admin.reviews.removeReply': 'Supprimer la réponse',
    'admin.reviews.saved': 'Avis mis à jour.',
    'admin.reviews.error.version-conflict': 'L’avis a été modifié entre-temps. Rechargez la page.',
    'admin.reviews.pending': '{count, plural, one {# avis à valider} other {# avis à valider}}',
    'admin.reviews.summary.store': 'Boutique',
    'admin.reviews.summary.products': 'Produits',
    'admin.reviews.summary.average': '{average}/5 · {count, plural, one {# avis publié} other {# avis publiés}}',
    'admin.reviews.summary.none': 'Pas encore d’avis publié',
    'admin.reviews.language': 'Langue',
    'admin.comments.title': 'Commentaires',
    'admin.comments.intro': 'Messages privés laissés par les visiteurs de la boutique en ligne.',
    'admin.comments.empty': 'Aucun commentaire pour le moment.',
    'admin.comments.search': 'Rechercher dans les messages',
    'admin.comments.status': 'Statut',
    'admin.comments.status.new': 'Nouveau',
    'admin.comments.status.handled': 'Traité',
    'admin.comments.filter.allStatuses': 'Tous',
    'admin.comments.column.message': 'Message',
    'admin.comments.markHandled': 'Marquer traité',
    'admin.comments.reopen': 'Rouvrir',
    'admin.feedback.button': 'Votre avis',
    'admin.feedback.title': 'Votre avis sur beinstore',
    'admin.feedback.intro': 'Une suggestion, un problème ? L’équipe beinstore lit chaque message.',
    'admin.feedback.rating': 'Votre note',
    'admin.feedback.category': 'Sujet',
    'admin.feedback.category.suggestion': 'Suggestion',
    'admin.feedback.category.problem': 'Problème',
    'admin.feedback.category.other': 'Autre',
    'admin.feedback.message': 'Votre message',
    'admin.feedback.send': 'Envoyer',
    'admin.feedback.sent': 'Merci pour votre retour !',
    'admin.feedback.close': 'Fermer',
    'admin.feedback.star': '{count, plural, one {# étoile} other {# étoiles}}',
    'admin.operator.feedback.title': 'Avis des marchands',
    'admin.operator.feedback.average': 'Note moyenne : {average}/5 ({count, plural, one {# avis} other {# avis}})',
    'admin.operator.feedback.empty': 'Aucun avis pour le moment.',
    'admin.operator.feedback.author': 'Marchand',
    'admin.operator.feedback.store': 'Boutique',
    'admin.operator.feedback.page': 'Page',
    'admin.operator.feedback.allCategories': 'Tous les sujets',
    'admin.operator.watch.title': 'Annonces',
    'admin.operator.watch.intro': 'Surveillez des mots dans le catalogue de chaque boutique. Masquez une annonce ou mettez la boutique hors ligne si elle n’est pas autorisée.',
    'admin.operator.watch.terms': 'Mots surveillés',
    'admin.operator.watch.termsHint': 'Un mot par ligne, au moins 4 caractères. Cherchés dans le titre, la description, l’adresse et les étiquettes.',
    'admin.operator.watch.termsSave': 'Enregistrer la liste',
    'admin.operator.watch.termsSaved': 'Liste enregistrée.',
    'admin.operator.watch.suggest': 'Ajouter les mots suggérés',
    'admin.operator.watch.flags': 'Annonces correspondantes',
    'admin.operator.watch.recent': 'Dernières annonces',
    'admin.operator.watch.empty': 'Rien ne correspond à la liste.',
    'admin.operator.watch.noTerms': 'Enregistrez des mots pour voir les annonces correspondantes.',
    'admin.operator.watch.matched': 'Correspondance',
    'admin.operator.watch.hide': 'Masquer l’annonce',
    'admin.operator.watch.confirmHide': 'Masquer cette annonce ?',
    'admin.operator.watch.hidden': 'Annonce masquée.',
    'admin.operator.watch.suspend': 'Suspendre la boutique',
    'admin.operator.watch.confirmSuspend': 'Mettre cette boutique hors ligne ?',
    'admin.operator.watch.suspended': 'Boutique suspendue.',
    'admin.operator.watch.resume': 'Rouvrir la boutique',
    'admin.operator.watch.resumed': 'Boutique rouverte.',
    'admin.operator.watch.reason': 'Motif',
    'admin.operator.watch.open': 'Ouvrir l’annonce',
    'admin.operator.watch.store': 'Boutique',
    'admin.operator.watch.product': 'Annonce',
    'admin.operator.watch.search': 'Rechercher des annonces',
    'admin.operator.watch.actions': 'Actions',
    'admin.operator.merchants': 'Marchands',
    'admin.operator.merchants.intro': 'Chaque compte propriétaire et les boutiques qu’il gère. Recherchez, filtrez, exportez ou importez l’identité seulement — un fichier ne crée jamais de boutique.',
    'admin.operator.merchants.search': 'Rechercher un e-mail, un nom ou une boutique',
    'admin.operator.merchants.empty': 'Aucun marchand.',
    'admin.operator.merchants.stores': 'Boutiques',
    'admin.operator.merchants.stores.any': 'Tous les nombres',
    'admin.operator.merchants.stores.one': 'Une boutique',
    'admin.operator.merchants.stores.several': 'Plusieurs boutiques',
    'admin.operator.merchants.presence': 'État des boutiques',
    'admin.operator.merchants.presence.any': 'Tous les états',
    'admin.operator.merchants.presence.unpublished': 'A une boutique non publiée',
    'admin.operator.merchants.presence.suspended': 'A une boutique suspendue',
    'admin.operator.merchants.presence.live': 'A une boutique en ligne',
    'admin.operator.merchants.storeCount': 'Boutiques',
    'admin.operator.merchants.created': 'Créé',
    'admin.operator.merchants.card': 'Marchand',
    'admin.operator.merchants.otherStores': 'Autres boutiques :',
    'admin.operator.merchants.noName': 'Sans nom affiché',
    'admin.operator.merchants.csv': 'Import et export',
    'admin.operator.merchants.export': 'Exporter (CSV)',
    'admin.operator.merchants.import': 'Importer un fichier CSV',
    'admin.operator.merchants.importHint': 'Colonnes : email (obligatoire), display_name, preferred_locale. Contrôle d’abord ; rien n’est écrit avant confirmation. Ne crée pas de boutique et n’envoie pas d’e-mail.',
    'admin.operator.merchants.importSummary': '{created} à créer, {updated} à mettre à jour. Aucune boutique n’est créée.',
    'admin.operator.merchants.importDone': 'Import terminé : {created} créés, {updated} mis à jour.',
    'admin.operator.merchants.importError.duplicate-email': 'Cet e-mail apparaît deux fois dans le fichier.',
    'admin.operator.merchants.importError.operator-account': 'Cette adresse est un opérateur de la plateforme. Elle ne peut pas posséder de boutique.',
    'admin.grid.pagination': 'Pagination',
    'admin.grid.range': '{from}–{to} sur {total}',
    'admin.grid.pageSize': 'Lignes par page',
    'admin.grid.previous': 'Page précédente',
    'admin.grid.next': 'Page suivante',
    'admin.grid.page': 'Page {page}',
    'admin.grid.reset': 'Réinitialiser',
    'admin.grid.noResults': 'Aucun résultat pour ces critères.',
    'admin.grid.from': 'Du',
    'admin.grid.to': 'Au',
    'admin.grid.filters': 'Filtres',
    'admin.order.paymentMethod': 'Mode de paiement',
    'admin.order.deliveryMethod': 'Mode de livraison',
    'admin.order.filter.allPaymentMethods': 'Tous les modes de paiement',
    'admin.order.filter.allDeliveryMethods': 'Tous les modes de livraison',
    'admin.inventory.filter.untracked': 'Stock non suivi',
    'admin.discount.search': 'Rechercher un code',
    'admin.discount.state': 'Situation',
    'admin.discount.state.active': 'Utilisable',
    'admin.discount.state.scheduled': 'Programmé',
    'admin.discount.state.expired': 'Expiré',
    'admin.discount.state.exhausted': 'Épuisé',
    'admin.discount.state.disabled': 'Désactivé',
    'admin.discount.filter.allStates': 'Toutes les situations',
    'admin.audit.filter.allActors': 'Tous les auteurs',
    'admin.audit.filter.action': 'Action contenant',
    // --- admin: errors (keyed by API problem code) ---
    'admin.error.invalid-code': 'Code incorrect. Vérifiez-le et réessayez.',
    'admin.error.code-expired': 'Ce code n’est plus valable. Demandez-en un nouveau.',
    'admin.error.too-many-requests': 'Trop de tentatives. Réessayez dans {seconds, plural, one {# seconde} other {# secondes}}.',
    'admin.error.email-unavailable': 'L’e-mail n’a pas pu être envoyé. Réessayez dans quelques instants.',
    'admin.error.unauthenticated': 'Votre session a expiré. Reconnectez-vous.',
    'admin.error.mfa-required': 'Confirmez d’abord votre identité avec votre deuxième facteur.',
    'admin.error.forbidden': 'Votre rôle ne permet pas cette action.',
    'admin.error.network': 'Problème de connexion. Vérifiez votre réseau et réessayez.',
    'admin.error.generic': 'Une erreur est survenue. Réessayez.',
    // --- admin: sign-in ---
    'admin.signIn.title': 'Connexion à {brand}',
    'admin.signIn.intro': 'Nous vous envoyons un code à 6 chiffres par e-mail. Pas de mot de passe.',
    'admin.signIn.email': 'Adresse e-mail',
    'admin.signIn.sendCode': 'Recevoir un code',
    'admin.signIn.codeTitle': 'Consultez vos e-mails',
    'admin.signIn.codeIntro': 'Saisissez le code envoyé à {email}.',
    'admin.signIn.code': 'Code à 6 chiffres',
    'admin.signIn.continue': 'Continuer',
    'admin.signIn.changeEmail': 'Utiliser une autre adresse',
    'admin.signIn.resend': 'Envoyer un nouveau code',
    // --- admin: MFA ---
    'admin.mfa.verifyTitle': 'Vérification en deux étapes',
    'admin.mfa.verifyIntro': 'Saisissez le code affiché dans votre application d’authentification.',
    'admin.mfa.code': 'Code de l’application',
    'admin.mfa.verify': 'Vérifier',
    'admin.mfa.useRecovery': 'Utiliser un code de secours',
    'admin.mfa.useApp': 'Utiliser l’application d’authentification',
    'admin.mfa.recoveryCode': 'Code de secours',
    'admin.mfa.setupTitle': 'Protégez votre compte',
    'admin.mfa.setupIntro': 'Pour protéger votre boutique, chaque connexion demande un code de votre téléphone. Scannez ce QR code avec une application d’authentification.',
    'admin.mfa.qrAlt': 'QR code à scanner avec votre application d’authentification',
    'admin.mfa.manualKey': 'Impossible de scanner ? Saisissez cette clé : {secret}',
    'admin.mfa.activate': 'Activer',
    'admin.mfa.recoveryTitle': 'Enregistrez vos codes de secours',
    'admin.mfa.recoveryIntro': 'Chaque code fonctionne une seule fois si vous perdez votre téléphone. Conservez-les en lieu sûr : ils ne seront plus affichés.',
    'admin.mfa.recoverySaved': 'Je les ai enregistrés',
    'admin.mfa.recoveryFileName': 'codes-de-secours-beinstore.txt',
    // --- admin: home ---
    'admin.home.title': 'Bonjour {name}',
    'admin.home.titleAnonymous': 'Bonjour',
    'admin.home.stores': 'Vos boutiques',
    'admin.home.noStores': 'Vous n’avez encore accès à aucune boutique.',
    'admin.home.auditLog': 'Journal d’audit',
    'admin.role.owner': 'Propriétaire',
    'admin.role.admin': 'Administrateur',
    'admin.role.staff': 'Équipe',
    'admin.role.support': 'Support',
    'admin.storeStatus.active': 'Active',
    'admin.storeStatus.suspended': 'Suspendue',
    'admin.storeStatus.provisioning': 'Non publiée',
    'admin.storeStatus.closed': 'Fermée',
    // --- admin: account ---
    'admin.account.title': 'Mon compte',
    'admin.account.email': 'Adresse e-mail',
    'admin.account.displayName': 'Nom affiché',
    'admin.account.preferredLocale': 'Langue préférée (e-mails et interface)',
    // --- admin: security ---
    'admin.security.title': 'Sécurité',
    'admin.security.sessions': 'Sessions actives',
    'admin.security.thisDevice': 'Cet appareil',
    'admin.security.unknownDevice': 'Appareil inconnu',
    'admin.security.lastActive': 'Dernière activité : {date}',
    'admin.security.revoke': 'Déconnecter',
    'admin.security.revokeOthers': 'Déconnecter toutes les autres sessions',
    'admin.security.revokedOthers': '{count, plural, =0 {Aucune autre session.} one {# session déconnectée.} other {# sessions déconnectées.}}',
    'admin.security.recoveryCodes': 'Codes de secours',
    'admin.security.recoveryRemaining': '{count, plural, =0 {Aucun code restant.} one {# code restant.} other {# codes restants.}}',
    'admin.security.regenerate': 'Générer de nouveaux codes',
    'admin.security.activity': 'Activité récente',
    'admin.security.event.sign_in.code_verified': 'Code de connexion validé',
    'admin.security.event.sign_in.completed': 'Connexion réussie',
    'admin.security.event.sign_in.mfa_failed': 'Échec de la vérification en deux étapes',
    'admin.security.event.account.created': 'Compte créé',
    'admin.security.event.mfa.totp_enrolled': 'Application d’authentification activée',
    'admin.security.event.mfa.recovery_codes_generated': 'Nouveaux codes de secours générés',
    'admin.security.event.mfa.recovery_code_used': 'Code de secours utilisé',
    'admin.security.event.session.revoked': 'Session déconnectée',
    'admin.security.event.session.logged_out': 'Déconnexion',
    'admin.security.mfa.title': 'Vérification en deux étapes',
    'admin.security.mfa.on': 'Activée : chaque connexion demande aussi un code de votre application d’authentification.',
    'admin.security.mfa.off': 'Désactivée : vous vous connectez avec le code reçu par e-mail. Activez-la pour demander aussi un code de votre téléphone.',
    'admin.security.mfa.enable': 'Activer',
    'admin.security.mfa.disable': 'Désactiver',
    'admin.security.mfa.codeHint': 'Inutile dans les 15 minutes qui suivent une connexion avec vérification en deux étapes.',
    'admin.security.mfa.disabled': 'La vérification en deux étapes est désactivée.',
    'admin.security.event.mfa.disabled': 'Vérification en deux étapes désactivée',
    // --- admin: audit log ---
    'admin.audit.title': 'Journal d’audit',
    'admin.audit.date': 'Date',
    'admin.audit.actor': 'Auteur',
    'admin.audit.action': 'Action',
    'admin.audit.target': 'Élément',
    'admin.audit.ip': 'Adresse IP',
    'admin.audit.empty': 'Aucun événement pour le moment.',
    'admin.audit.actor.system': 'Système',
    'admin.audit.actor.user': 'Utilisateur',
    'admin.audit.actor.api_client': 'Application',
    // --- module 4: stores, team, invitations ---
    'email.invitation.subject': 'Invitation à rejoindre {store} sur {brand}',
    'email.invitation.heading': 'Vous êtes invité à rejoindre {store}',
    'email.invitation.intro': '{inviter} vous invite à rejoindre l’équipe de {store} sur {brand} avec le rôle « {role} ».',
    'email.invitation.action': 'Voir l’invitation',
    'email.invitation.expiry': 'Cette invitation expire dans {days, plural, one {# jour} other {# jours}}.',
    'email.invitation.ignore': 'Si vous ne connaissez pas cette boutique, ignorez ce message.',
    'admin.error.conflict': 'Cette action est en conflit avec l’état actuel (elle a peut-être déjà été faite).',
    'admin.home.createStore': 'Créer une boutique',
    'admin.home.openStore': 'Ouvrir',
    'admin.store.new.title': 'Créez votre boutique',
    'admin.store.new.intro': 'Choisissez un nom et une adresse. Vous ajouterez vos produits ensuite.',
    'admin.store.nameIn': 'Nom de la boutique ({language})',
    'admin.store.slug': 'Adresse de la boutique',
    'admin.store.slugHint': 'Lettres minuscules, chiffres et tirets. Elle ne pourra pas être modifiée.',
    'admin.store.slugAvailable': '{host} est disponible.',
    'admin.store.slug.invalid': 'Utilisez 3 à 40 lettres minuscules, chiffres ou tirets simples.',
    'admin.store.slug.reserved': 'Cette adresse est réservée.',
    'admin.store.slug.taken': 'Cette adresse est déjà utilisée.',
    'admin.store.defaultLocale': 'Langue principale de la boutique',
    'admin.store.enabledLocales': 'Langues de la boutique',
    'admin.store.create': 'Créer la boutique',
    'admin.store.settings': 'Paramètres',
    'admin.store.team': 'Équipe',
    'admin.store.addresses': 'Adresses',
    'admin.store.error.defaultLocale': 'La langue principale doit faire partie des langues de la boutique et avoir un nom.',
    'admin.team.members': 'Membres',
    'admin.team.you': 'Vous',
    'admin.team.role': 'Rôle',
    'admin.team.roleFor': 'Rôle de {name}',
    'admin.team.remove': 'Retirer',
    'admin.team.removeFor': 'Retirer {name}',
    'admin.team.invitations': 'Invitations en attente',
    'admin.team.noInvitations': 'Aucune invitation en attente.',
    'admin.team.invite': 'Inviter une personne',
    'admin.team.inviteLocale': 'Langue de l’invitation',
    'admin.team.send': 'Envoyer l’invitation',
    'admin.team.sent': 'Invitation envoyée.',
    'admin.team.expires': 'Expire le {date}',
    'admin.team.cancelInvitation': 'Annuler',
    'admin.invitation.title': 'Rejoindre {store}',
    'admin.invitation.intro': 'Vous êtes invité à rejoindre {store} avec le rôle « {role} ».',
    'admin.invitation.accept': 'Accepter l’invitation',
    'admin.invitation.mismatch': 'Cette invitation a été envoyée à {email}. Connectez-vous avec cette adresse pour l’accepter.',
    'admin.invitation.invalid': 'Cette invitation n’est plus valable. Demandez-en une nouvelle au propriétaire de la boutique.',
    'admin.media.title': 'Médiathèque',
    'admin.media.upload': 'Ajouter des images',
    'admin.media.uploadHint': 'JPEG, PNG, WebP ou AVIF. Les informations cachées dans les photos (position GPS, appareil) sont supprimées.',
    'admin.media.uploading': 'Envoi en cours : {done} sur {total}…',
    'admin.media.uploaded': '{count, plural, one {# image ajoutée.} other {# images ajoutées.}}',
    'admin.media.empty': 'Aucune image pour le moment.',
    'admin.media.dimensions': '{width} × {height} px',
    'admin.media.alt': 'Description de l’image ({language})',
    'admin.media.altHint': 'Lue aux personnes malvoyantes et utilisée par les moteurs de recherche.',
    'admin.media.edit': 'Modifier',
    'admin.media.editFor': 'Modifier la description de {name}',
    'admin.media.delete': 'Supprimer',
    'admin.media.deleteFor': 'Supprimer {name}',
    'admin.media.confirmDelete': 'Confirmer la suppression',
    'admin.media.cancel': 'Annuler',
    'admin.media.deleted': 'Image supprimée.',
    'admin.media.error.payload-too-large': '{name} : le fichier est trop volumineux.',
    'admin.media.error.unsupported-media-type': '{name} : format non pris en charge. Utilisez JPEG, PNG, WebP ou AVIF.',
    'admin.media.error.invalid-image': '{name} : l’image est illisible ou ses dimensions sont trop grandes.',
    'admin.media.error.service-unavailable': 'La médiathèque est indisponible pour le moment. Réessayez plus tard.',
    'admin.media.error.file': 'Échec de l’envoi de {name} : {message}',
    'admin.catalog.products': 'Produits',
    'admin.catalog.collections': 'Collections',
    'admin.catalog.export': 'Exporter (CSV)',
    'admin.catalog.import': 'Importer un fichier CSV',
    'admin.catalog.importHint': 'Une ligne par variante. Le fichier est d’abord vérifié : rien n’est modifié avant votre confirmation.',
    'admin.catalog.importChecking': 'Vérification du fichier…',
    'admin.catalog.importSummary': '{products, plural, one {# produit} other {# produits}} : {created} à créer, {updated} à mettre à jour.',
    'admin.catalog.importApply': 'Importer',
    'admin.catalog.importDone': 'Import terminé : {created} créés, {updated} mis à jour.',
    'admin.catalog.importErrors': 'Le fichier contient des erreurs. Corrigez-les puis réessayez.',
    'admin.catalog.importErrorLine': 'Ligne {line} : {message}',
    'admin.catalog.importErrorCell': 'Ligne {line}, colonne {column} : {message}',
    'admin.catalog.importError.invalid-csv': 'Le fichier n’est pas un CSV valide.',
    'admin.catalog.importError.no-rows': 'Le fichier ne contient aucun produit.',
    'admin.catalog.importError.unknown-column': 'Colonne inconnue.',
    'admin.catalog.importError.missing-column': 'Colonne obligatoire absente.',
    'admin.catalog.importError.too-many-rows': 'Trop de lignes : 10 000 au plus par fichier.',
    'admin.catalog.importError.too-many-products': 'Trop de produits : 2 000 au plus par fichier.',
    'admin.catalog.importError.required': 'Valeur obligatoire.',
    'admin.catalog.importError.differs': 'Différent de la première ligne de ce produit.',
    'admin.catalog.importError.option-numbering': 'Les options se numérotent à partir de 1, sans trou.',
    'admin.catalog.importError.invalid-amount': 'Montant en dinars avec au plus 3 décimales, par exemple 25.500.',
    'admin.catalog.importError.whole-grams': 'Poids en grammes entiers.',
    'admin.catalog.importError.sku-used': 'Ce SKU appartient à un autre produit.',
    'admin.catalog.importError.invalid': 'Valeur non valide.',
    'admin.product.new': 'Nouveau produit',
    'admin.product.edit': 'Modifier le produit',
    'admin.product.search': 'Rechercher (nom, adresse ou SKU)',
    'admin.product.statusFilter': 'Statut',
    'admin.product.allStatuses': 'Tous',
    'admin.product.status.draft': 'Brouillon',
    'admin.product.status.active': 'En vente',
    'admin.product.status.archived': 'Archivé',
    'admin.product.empty': 'Aucun produit pour le moment.',
    'admin.product.noMatch': 'Aucun produit ne correspond à votre recherche.',
    'admin.product.column.product': 'Produit',
    'admin.product.column.status': 'Statut',
    'admin.product.column.variants': 'Variantes',
    'admin.product.column.price': 'Prix',
    'admin.product.column.updated': 'Modifié le',
    'admin.product.priceRange': '{min} – {max}',
    'admin.product.titleIn': 'Nom ({language})',
    'admin.product.descriptionIn': 'Description ({language})',
    'admin.product.handle': 'Adresse de la page',
    'admin.product.handleHint': 'Lettres minuscules, chiffres et tirets. Laissez vide pour la déduire du nom.',
    'admin.product.tags': 'Étiquettes',
    'admin.product.tagsHint': 'Séparées par des virgules.',
    'admin.product.details': 'Informations',
    'admin.product.options': 'Options',
    'admin.product.optionsHint': 'Par exemple taille ou couleur. Chaque combinaison de valeurs devient une variante.',
    'admin.product.addOption': 'Ajouter une option',
    'admin.product.removeOption': 'Retirer l’option {number}',
    'admin.product.optionNameIn': 'Nom de l’option {number} ({language})',
    'admin.product.optionValues': 'Valeurs de l’option {number}',
    'admin.product.valueIn': 'Valeur {index} ({language})',
    'admin.product.addValue': 'Ajouter une valeur',
    'admin.product.removeValue': 'Retirer la valeur {index}',
    'admin.product.variants': 'Prix et variantes',
    'admin.product.variant': 'Variante',
    'admin.product.price': 'Prix (DT)',
    'admin.product.priceFor': 'Prix de {variant} (DT)',
    'admin.product.compareAt': 'Prix barré (DT)',
    'admin.product.compareAtFor': 'Prix barré de {variant} (DT)',
    'admin.product.sku': 'SKU',
    'admin.product.skuFor': 'SKU de {variant}',
    'admin.product.barcode': 'Code-barres',
    'admin.product.weight': 'Poids (g)',
    'admin.product.tooManyVariants': 'Au plus {max} variantes : réduisez le nombre de valeurs.',
    'admin.product.images': 'Images',
    'admin.product.noImages': 'Aucune image.',
    'admin.product.addImages': 'Choisir dans la médiathèque',
    'admin.product.closePicker': 'Fermer',
    'admin.product.selectImage': 'Choisir {name}',
    'admin.product.moveUp': 'Monter {name}',
    'admin.product.moveDown': 'Descendre {name}',
    'admin.product.removeImage': 'Retirer {name}',
    'admin.product.save': 'Enregistrer le produit',
    'admin.product.saved': 'Produit enregistré.',
    'admin.product.delete': 'Supprimer le produit',
    'admin.product.confirmDelete': 'Confirmer la suppression du produit',
    'admin.product.deleted': 'Produit supprimé.',
    'admin.product.invalidPrice': 'Montant en dinars avec au plus 3 décimales, par exemple 25,500.',
    'admin.product.error.version-conflict': 'Ce produit a été modifié entre-temps. Rechargez la page puis refaites vos changements.',
    'admin.product.error.handle-taken': 'Cette adresse est déjà utilisée.',
    'admin.product.error.sku-taken': 'Un SKU est déjà utilisé par un autre produit.',
    'admin.product.error.validation': 'Certains champs ne sont pas valides. Vérifiez le formulaire.',
    'admin.collection.new': 'Nouvelle collection',
    'admin.collection.edit': 'Modifier la collection',
    'admin.collection.empty': 'Aucune collection pour le moment.',
    'admin.collection.productCount': '{count, plural, one {# produit} other {# produits}}',
    'admin.collection.products': 'Produits de la collection',
    'admin.collection.noProducts': 'Aucun produit dans cette collection.',
    'admin.collection.findProducts': 'Rechercher des produits à ajouter',
    'admin.collection.addProduct': 'Ajouter {name}',
    'admin.collection.removeProduct': 'Retirer {name}',
    'admin.collection.status.draft': 'Brouillon',
    'admin.collection.status.active': 'Visible',
    'admin.collection.save': 'Enregistrer la collection',
    'admin.collection.saved': 'Collection enregistrée.',
    'admin.collection.delete': 'Supprimer la collection',
    'admin.collection.confirmDelete': 'Confirmer la suppression de la collection',
    'admin.collection.deleted': 'Collection supprimée.',
    'admin.catalog.csv': 'Import et export',
    'admin.inventory.title': 'Stock',
    'admin.inventory.search': 'Rechercher (nom ou SKU)',
    'admin.inventory.filter': 'Afficher',
    'admin.inventory.filter.all': 'Tous les articles',
    'admin.inventory.filter.tracked': 'Stock suivi',
    'admin.inventory.filter.out-of-stock': 'En rupture',
    'admin.inventory.empty': 'Aucun article.',
    'admin.inventory.column.item': 'Article',
    'admin.inventory.column.onHand': 'En stock',
    'admin.inventory.column.reserved': 'Réservé',
    'admin.inventory.column.available': 'Disponible',
    'admin.inventory.column.state': 'État',
    'admin.inventory.state.untracked': 'Non suivi (vente illimitée)',
    'admin.inventory.state.backorder': 'Vente en rupture acceptée',
    'admin.inventory.state.out': 'En rupture',
    'admin.inventory.state.in': 'Disponible',
    'admin.inventory.manage': 'Gérer le stock de {name}',
    'admin.inventory.settings': 'Suivi du stock',
    'admin.inventory.track': 'Suivre le stock de cet article',
    'admin.inventory.allowBackorder': 'Continuer à vendre en rupture de stock',
    'admin.inventory.saveSettings': 'Enregistrer les réglages',
    'admin.inventory.settingsSaved': 'Réglages enregistrés.',
    'admin.inventory.adjust': 'Ajuster le stock',
    'admin.inventory.reason': 'Motif',
    'admin.inventory.reason.received': 'Réception',
    'admin.inventory.reason.returned': 'Retour client',
    'admin.inventory.reason.damaged': 'Abîmé ou perdu',
    'admin.inventory.reason.correction': 'Correction',
    'admin.inventory.reason.count': 'Inventaire',
    'admin.inventory.reason.reserved': 'Réservé',
    'admin.inventory.reason.released': 'Libéré',
    'admin.inventory.reason.expired': 'Réservation expirée',
    'admin.inventory.reason.committed': 'Vendu',
    'admin.inventory.reason.tracking': 'Réglages du suivi',
    'admin.inventory.quantity': 'Quantité',
    'admin.inventory.quantityHint': 'Nombre d’unités ajoutées ou retirées.',
    'admin.inventory.correctionHint': 'Un nombre négatif retire du stock.',
    'admin.inventory.note': 'Note (facultative)',
    'admin.inventory.apply': 'Enregistrer l’ajustement',
    'admin.inventory.count': 'Inventaire physique',
    'admin.inventory.counted': 'Quantité comptée',
    'admin.inventory.saveCount': 'Enregistrer l’inventaire',
    'admin.inventory.saved': 'Stock mis à jour.',
    'admin.inventory.history': 'Historique',
    'admin.inventory.noHistory': 'Aucun mouvement pour le moment.',
    'admin.inventory.column.date': 'Date',
    'admin.inventory.column.change': 'Variation',
    'admin.inventory.column.after': 'Stock après',
    'admin.inventory.column.note': 'Note',
    'admin.inventory.error.stock-conflict': 'Le stock ne peut pas descendre sous zéro ni sous les quantités réservées.',
    'admin.inventory.error.quantity': 'Saisissez un nombre entier.',
    'storefront.skipToContent': 'Aller au contenu',
    'storefront.menu': 'Menu principal',
    'storefront.language': 'Langue',
    'storefront.search': 'Rechercher',
    'storefront.searchLabel': 'Rechercher un produit',
    'storefront.searchTitle': 'Recherche',
    'storefront.results': '{count, plural, =0 {Aucun résultat} one {# résultat} other {# résultats}} pour « {query} »',
    'storefront.noResults': 'Aucun produit ne correspond à votre recherche.',
    'storefront.searchUnavailable': 'La recherche est momentanément indisponible. Réessayez dans un instant.',
    'storefront.sort': 'Trier par',
    'storefront.sort.relevance': 'Pertinence',
    'storefront.sort.price-asc': 'Prix croissant',
    'storefront.sort.price-desc': 'Prix décroissant',
    'storefront.sort.newest': 'Nouveautés',
    'storefront.apply': 'Appliquer',
    'storefront.previous': 'Page précédente',
    'storefront.next': 'Page suivante',
    'storefront.available': 'En stock',
    'storefront.soldOut': 'Épuisé',
    'storefront.from': 'À partir de {price}',
    'storefront.oldPrice': 'Ancien prix : {price}',
    'storefront.viewAll': 'Voir tout',
    'storefront.emptyCollection': 'Aucun produit pour le moment.',
    'storefront.productImages': 'Images de {title}',
    'storefront.noCombination': 'Cette combinaison n’est pas disponible.',
    'storefront.preview': 'Aperçu : cette version de la boutique n’est pas encore publiée.',
    'storefront.notFound': 'Page introuvable',
    'storefront.notFoundText': 'La page que vous cherchez n’existe pas ou n’est plus disponible.',
    'storefront.backHome': 'Retour à l’accueil',
    'storefront.storeNotFound': 'Cette boutique n’existe pas.',
    'storefront.storeUnavailable': 'Cette boutique est momentanément indisponible.',
    'storefront.error': 'Une erreur est survenue.',
    'storefront.retry': 'Réessayer',
    'storefront.poweredBy': 'Boutique créée avec {brand}',
    'admin.theme.title': 'Apparence de la boutique',
    'admin.theme.colors': 'Couleurs et identité',
    'admin.theme.color.background': 'Fond',
    'admin.theme.color.text': 'Texte',
    'admin.theme.color.accent': 'Boutons et liens',
    'admin.theme.color.accentText': 'Texte des boutons',
    'admin.theme.contrastLow': 'Contraste insuffisant ({ratio}:1, minimum 4,5:1) : le texte serait difficile à lire.',
    'admin.theme.logo': 'Logo',
    'admin.theme.noImage': 'Aucune image',
    'admin.theme.announcementIn': 'Bandeau d’annonce ({language})',
    'admin.theme.navigation': 'Menu',
    'admin.theme.addNavItem': 'Ajouter un lien au menu',
    'admin.theme.navLabelIn': 'Libellé du lien {number} ({language})',
    'admin.theme.linkFor': 'Destination du lien {number}',
    'admin.theme.removeNav': 'Retirer le lien {number}',
    'admin.theme.link.none': 'Aucune',
    'admin.theme.link.home': 'Accueil',
    'admin.theme.link.search': 'Recherche',
    'admin.theme.link.collection': 'Collection : {name}',
    'admin.theme.link.product': 'Produit : {name}',
    'admin.theme.sections': 'Page d’accueil',
    'admin.theme.sectionType': 'Type de section',
    'admin.theme.addSection': 'Ajouter la section',
    'admin.theme.section.hero': 'Bannière',
    'admin.theme.section.featured-collection': 'Collection mise en avant',
    'admin.theme.section.product-grid': 'Derniers produits',
    'admin.theme.section.rich-text': 'Texte',
    'admin.theme.section.image-with-text': 'Image et texte',
    'admin.theme.sectionN': 'Section {number} : {type}',
    'admin.theme.headingIn': 'Titre ({language})',
    'admin.theme.textIn': 'Texte ({language})',
    'admin.theme.buttonLabelIn': 'Texte du bouton ({language})',
    'admin.theme.buttonLink': 'Destination du bouton',
    'admin.theme.image': 'Image',
    'admin.theme.imagePosition': 'Position de l’image',
    'admin.theme.imagePosition.start': 'Avant le texte',
    'admin.theme.imagePosition.end': 'Après le texte',
    'admin.theme.collection': 'Collection',
    'admin.theme.limit': 'Nombre de produits',
    'admin.theme.moveUp': 'Monter la section {number}',
    'admin.theme.moveDown': 'Descendre la section {number}',
    'admin.theme.remove': 'Retirer la section {number}',
    'admin.theme.save': 'Enregistrer le brouillon',
    'admin.theme.saved': 'Brouillon enregistré.',
    'admin.theme.preview': 'Prévisualiser',
    'admin.theme.openPreview': 'Ouvrir l’aperçu',
    'admin.theme.previewHint': 'Le lien d’aperçu reste valable une heure.',
    'admin.theme.publish': 'Publier',
    'admin.theme.published': 'Publié : vos clients voient maintenant cette version.',
    'admin.theme.unpublished': 'Des modifications ne sont pas encore publiées.',
    'admin.theme.upToDate': 'La boutique affiche la dernière version publiée.',
    'admin.theme.history': 'Versions publiées',
    'admin.theme.noHistory': 'Rien n’a encore été publié.',
    'admin.theme.version': 'Version {number}',
    'admin.theme.current': 'En ligne',
    'admin.theme.restore': 'Restaurer la version {number}',
    'admin.theme.restored': 'Version restaurée dans le brouillon. Publiez-la pour la mettre en ligne.',
    'admin.theme.error.version-conflict': 'L’apparence a été modifiée entre-temps. Rechargez la page.',
    'admin.theme.template': 'Modèle',
    'admin.theme.template.souk': 'Souk',
    'admin.theme.template.atelier': 'Atelier',
    'admin.theme.template.ledger': 'Ledger',
    'admin.theme.template.hint': 'Appliquer un modèle remplace les couleurs et l’accueil du brouillon. Le logo, le menu et les pages restent. Les clients le voient après publication.',
    'admin.theme.template.apply': 'Appliquer {name}',
    'admin.theme.template.confirm': 'Remplacer les couleurs et l’accueil du brouillon par ce modèle ? Le site en ligne ne change qu’à la publication.',
    'admin.theme.template.applied': 'Modèle appliqué au brouillon. Publiez-le pour l’afficher aux clients.',
    'admin.theme.link.page': 'Page : {name}',
    'admin.theme.pages': 'Pages',
    'admin.theme.addPage': 'Ajouter une page',
    'admin.theme.pageHandle': 'Adresse de la page {number}',
    'admin.theme.pageTitleIn': 'Titre de la page {number} ({language})',
    'admin.theme.removePage': 'Supprimer la page {number}',
    'admin.theme.pageSectionType': 'Type de section de la page {number}',
    'admin.theme.addPageSection': 'Ajouter une section à la page {number}',
    'admin.theme.slots.product': 'Page produit',
    'admin.theme.slots.collection': 'Page collection',
    'admin.theme.slots.cart': 'Panier',
    'admin.theme.slots.before': 'Avant le contenu',
    'admin.theme.slots.after': 'Après le contenu',
    'admin.theme.slotSectionType': 'Type de section ({place})',
    'admin.theme.addSlotSection': 'Ajouter une section ({place})',
    'admin.theme.place.product.before': 'avant le produit',
    'admin.theme.place.product.after': 'après le produit',
    'admin.theme.place.collection.before': 'avant la collection',
    'admin.theme.place.collection.after': 'après la collection',
    'admin.theme.place.cart.before': 'avant le panier',
    'admin.theme.place.cart.after': 'après le panier',
    'admin.theme.reservedHandle': 'Cette adresse est déjà utilisée par la boutique (panier, commande, recherche…).',
    'admin.theme.duplicateHandle': 'Deux pages ne peuvent pas avoir la même adresse.',
    // --- module 10: checkout settings, discount codes, orders ---
    'admin.checkout.title': 'Paiement et livraison',
    'admin.checkout.unavailable': 'La boutique ne prend pas encore de commandes : activez au moins un moyen de paiement et un mode de livraison.',
    'admin.checkout.available': 'La boutique prend des commandes.',
    'admin.checkout.saved': 'Réglages enregistrés.',
    'admin.checkout.error.validation': 'Vérifiez les champs signalés.',
    'admin.checkout.error.version-conflict': 'Les réglages ont été modifiés entre-temps. Rechargez la page.',
    'admin.checkout.payments': 'Moyens de paiement',
    'admin.checkout.cashOnDelivery': 'Paiement à la livraison',
    'admin.checkout.bankTransfer': 'Virement bancaire (vous confirmez la réception)',
    'admin.checkout.bankInstructionsIn': 'Instructions de virement ({language})',
    'admin.checkout.bankInstructionsHint': 'RIB et titulaire du compte : affichés au client et dans l’e-mail de confirmation.',
    'admin.checkout.delivery': 'Livraison',
    'admin.checkout.shippingEnabled': 'Livrer à domicile',
    'admin.checkout.zone': 'Zone {number}',
    'admin.checkout.zoneNameIn': 'Nom de la zone ({language})',
    'admin.checkout.zonePrice': 'Frais de livraison (DT)',
    'admin.checkout.zoneFreeOver': 'Livraison offerte à partir de (DT, facultatif)',
    'admin.checkout.zoneGovernorates': 'Gouvernorats desservis',
    'admin.checkout.addZone': 'Ajouter une zone',
    'admin.checkout.removeZone': 'Supprimer la zone {number}',
    'admin.checkout.pickupEnabled': 'Retrait en magasin',
    'admin.checkout.pickupAddressIn': 'Adresse de retrait ({language})',
    'admin.checkout.taxes': 'Taxes',
    'admin.checkout.taxesEnabled': 'Calculer la TVA (entreprise assujettie)',
    'admin.checkout.taxesHint': 'Les taux sont les vôtres : vérifiez-les avec votre comptable. beinstore n’applique aucun taux par défaut.',
    'admin.checkout.pricesIncludeTax': 'Les prix de la boutique',
    'admin.checkout.pricesIncludeTax.yes': 'incluent la TVA',
    'admin.checkout.pricesIncludeTax.no': 'sont hors taxes (TVA ajoutée au panier)',
    'admin.checkout.fiscalId': 'Matricule fiscal',
    'admin.checkout.taxClass': 'Taux {number}',
    'admin.checkout.taxClassKey': 'Code (utilisé par les produits et le CSV)',
    'admin.checkout.taxClassNameIn': 'Nom ({language})',
    'admin.checkout.taxClassRate': 'Taux (%)',
    'admin.checkout.addTaxClass': 'Ajouter un taux',
    'admin.checkout.removeTaxClass': 'Supprimer le taux {number}',
    'admin.checkout.defaultClass': 'Taux des produits sans taux',
    'admin.checkout.shippingClass': 'Taux appliqué à la livraison',
    'admin.checkout.noClass': 'Aucun (non taxé)',
    'admin.checkout.fee': 'Frais fixes par commande',
    'admin.checkout.feeAmount': 'Montant (DT, vide = aucun)',
    'admin.checkout.feeLabelIn': 'Libellé ({language})',
    'admin.checkout.feeHint': 'Par exemple un timbre fiscal, si vous l’appliquez.',
    'admin.checkout.invalidAmount': 'Montant invalide.',
    'admin.checkout.invalidRate': 'Taux invalide (0 à 100, deux décimales au plus).',
    'admin.checkout.invalidKey': 'Lettres minuscules, chiffres et tirets.',
    'admin.discount.title': 'Codes promo',
    'admin.discount.new': 'Nouveau code',
    'admin.discount.empty': 'Aucun code promo pour le moment.',
    'admin.discount.column.code': 'Code',
    'admin.discount.column.value': 'Réduction',
    'admin.discount.column.used': 'Utilisations',
    'admin.discount.column.status': 'État',
    'admin.discount.column.validity': 'Validité',
    'admin.discount.kind': 'Type de réduction',
    'admin.discount.kind.percentage': 'Pourcentage',
    'admin.discount.kind.fixed_amount': 'Montant fixe',
    'admin.discount.kind.free_shipping': 'Livraison offerte',
    'admin.discount.value.percentage': '{percent} %',
    'admin.discount.code': 'Code',
    'admin.discount.codeHint': 'Lettres, chiffres, - et _ (3 à 40). Les clients peuvent le saisir en minuscules.',
    'admin.discount.percent': 'Pourcentage (%)',
    'admin.discount.amount': 'Montant (DT)',
    'admin.discount.minSubtotal': 'Montant minimum du panier (DT, facultatif)',
    'admin.discount.startsOn': 'Valable à partir du (facultatif)',
    'admin.discount.endsOn': 'Valable jusqu’au, inclus (facultatif)',
    'admin.discount.datesHint': 'Dates à l’heure de Tunis.',
    'admin.discount.usageLimit': 'Nombre total d’utilisations (facultatif)',
    'admin.discount.perCustomerLimit': 'Utilisations par client (facultatif)',
    'admin.discount.perCustomerHint': 'Un client est reconnu par son numéro de téléphone.',
    'admin.discount.status': 'État',
    'admin.discount.status.active': 'Actif',
    'admin.discount.status.disabled': 'Désactivé',
    'admin.discount.always': 'Sans limite de date',
    'admin.discount.from': 'À partir du {date}',
    'admin.discount.until': 'Jusqu’au {date}',
    'admin.discount.between': 'Du {start} au {end}',
    'admin.discount.edit': 'Modifier le code',
    'admin.discount.saved': 'Code enregistré.',
    'admin.discount.error.conflict': 'Ce code existe déjà.',
    'admin.discount.error.version-conflict': 'Le code a été modifié entre-temps. Rechargez la page.',
    'admin.discount.error.validation': 'Vérifiez les champs signalés.',
    'admin.discount.invalidPercent': 'Entre 0,01 et 100.',
    'admin.discount.invalidNumber': 'Nombre entier positif.',
    'admin.discount.invalidDates': 'La fin doit être après le début.',
    'admin.order.title': 'Commandes',
    'admin.order.search': 'Rechercher (nom, téléphone ou numéro)',
    'admin.order.empty': 'Aucune commande pour le moment.',
    'admin.order.column.number': 'N°',
    'admin.order.column.date': 'Date',
    'admin.order.column.customer': 'Client',
    'admin.order.column.total': 'Total',
    'admin.order.column.payment': 'Paiement',
    'admin.order.column.delivery': 'Livraison',
    'admin.order.number': 'Commande n° {number}',
    'admin.order.open': 'Voir la commande n° {number}',
    'admin.order.payment.cash_on_delivery': 'À la livraison',
    'admin.order.payment.bank_transfer': 'Virement bancaire',
    'admin.order.paymentStatus': 'Statut du paiement',
    'admin.order.paymentStatus.pending': 'En attente',
    'admin.order.paymentStatus.paid': 'Payée',
    'admin.order.delivery.shipping': 'Livraison à domicile',
    'admin.order.delivery.pickup': 'Retrait en magasin',
    'admin.order.placedAt': 'Passée le {date}',
    'admin.order.customer': 'Client',
    'admin.order.phone': 'Téléphone',
    'admin.order.email': 'E-mail',
    'admin.order.address': 'Adresse de livraison',
    'admin.order.note': 'Note du client',
    'admin.order.items': 'Articles',
    'admin.order.column.item': 'Article',
    'admin.order.column.unitPrice': 'Prix unitaire',
    'admin.order.column.quantity': 'Quantité',
    'admin.order.subtotal': 'Sous-total',
    'admin.order.discount': 'Réduction ({code})',
    'admin.order.shipping': 'Livraison',
    'admin.order.tax': 'TVA',
    'admin.order.taxIncluded': 'dont TVA',
    'admin.order.taxLine': 'TVA {rate} % sur {net} : {tax}',
    'admin.order.fee': 'Frais ({label})',
    'admin.order.total': 'Total',
    'admin.order.instructions': 'Instructions envoyées au client',
    'admin.order.fiscalNote': 'Montants enregistrés au moment de la commande ; ils ne changent plus.',
    'admin.product.taxClass': 'Taux de TVA',
    'admin.product.taxClass.default': 'Taux par défaut de la boutique',
    'admin.product.taxClass.unknown': '{key} (absent des réglages : taux par défaut appliqué)',
    // --- module 10: storefront cart and checkout ---
    'storefront.cart': 'Panier',
    'storefront.cartWithCount': 'Panier ({count, plural, =0 {vide} one {# article} other {# articles}})',
    'storefront.cart.title': 'Votre panier',
    'storefront.cart.empty': 'Votre panier est vide.',
    'storefront.cart.continue': 'Continuer vos achats',
    'storefront.cart.product': 'Article',
    'storefront.cart.price': 'Prix',
    'storefront.cart.quantity': 'Quantité',
    'storefront.cart.quantityOf': 'Quantité de {title}',
    'storefront.cart.lineTotal': 'Total',
    'storefront.cart.update': 'Mettre à jour',
    'storefront.cart.remove': 'Retirer',
    'storefront.cart.removeItem': 'Retirer {title} du panier',
    'storefront.cart.unavailable': 'N’est plus disponible : retirez-le pour commander.',
    'storefront.cart.subtotal': 'Sous-total',
    'storefront.cart.discount': 'Réduction ({code})',
    'storefront.cart.shipping': 'Livraison',
    'storefront.cart.shippingLater': 'Calculée à l’étape suivante',
    'storefront.cart.free': 'Offerte',
    'storefront.cart.tax': 'TVA',
    'storefront.cart.taxIncluded': 'dont TVA',
    'storefront.cart.fee': 'Frais',
    'storefront.cart.total': 'Total',
    'storefront.cart.checkout': 'Passer la commande',
    'storefront.cart.checkoutUnavailable': 'Cette boutique ne prend pas encore de commandes en ligne.',
    'storefront.cart.add': 'Ajouter au panier',
    'storefront.cart.error.sold-out': 'Ce produit est épuisé.',
    'storefront.cart.error.full': 'Votre panier est plein.',
    'storefront.cart.error.unavailable': 'Ce produit n’est plus disponible.',
    'storefront.cart.error.too-many': 'Trop de tentatives. Réessayez dans quelques minutes.',
    'storefront.cart.error.generic': 'Une erreur est survenue. Réessayez.',
    'storefront.discount.label': 'Code promo',
    'storefront.discount.apply': 'Appliquer',
    'storefront.discount.remove': 'Retirer le code',
    'storefront.discount.applied': 'Code promo appliqué.',
    'storefront.discount.refusal.unknown': 'Ce code n’existe pas.',
    'storefront.discount.refusal.inactive': 'Ce code n’est plus actif.',
    'storefront.discount.refusal.not-started': 'Ce code n’est pas encore valable.',
    'storefront.discount.refusal.expired': 'Ce code a expiré.',
    'storefront.discount.refusal.minimum': 'Le montant du panier est insuffisant pour ce code.',
    'storefront.discount.refusal.exhausted': 'Ce code a atteint sa limite d’utilisation.',
    'storefront.discount.refusal.customer-limit': 'Vous avez déjà utilisé ce code.',
    'storefront.discount.refusal.too-many': 'Trop d’essais. Réessayez plus tard.',
    'storefront.discount.refusal.error': 'Le code n’a pas pu être vérifié. Réessayez.',
    'storefront.checkout.title': 'Commande',
    'storefront.checkout.backToCart': 'Retour au panier',
    'storefront.checkout.deliveryChoice': 'Mode de livraison',
    'storefront.checkout.pickup': 'Retrait en magasin',
    'storefront.checkout.pickupAt': 'Retrait en magasin : {address}',
    'storefront.checkout.shippingTo': 'Livraison à domicile',
    'storefront.checkout.governorate': 'Gouvernorat',
    'storefront.checkout.choose': 'Choisir…',
    'storefront.checkout.governoratePrice': '{name} — {price}',
    'storefront.checkout.governoratePriceFree': '{name} — {price}, offerte dès {amount}',
    'storefront.checkout.continue': 'Continuer',
    'storefront.checkout.change': 'Modifier la livraison',
    'storefront.checkout.notServed': 'La boutique ne livre pas ce gouvernorat.',
    'storefront.checkout.contact': 'Vos coordonnées',
    'storefront.checkout.name': 'Nom et prénom',
    'storefront.checkout.phone': 'Téléphone',
    'storefront.checkout.phoneHint': 'Numéro tunisien à 8 chiffres, ou international avec +',
    'storefront.checkout.email': 'E-mail (facultatif, pour recevoir la confirmation)',
    'storefront.checkout.address': 'Adresse de livraison',
    'storefront.checkout.city': 'Ville',
    'storefront.checkout.line1': 'Adresse (rue, numéro)',
    'storefront.checkout.line2': 'Complément d’adresse (facultatif)',
    'storefront.checkout.postalCode': 'Code postal (facultatif)',
    'storefront.checkout.payment': 'Paiement',
    'storefront.checkout.cashOnDelivery': 'Paiement à la livraison',
    'storefront.checkout.bankTransfer': 'Virement bancaire',
    'storefront.checkout.note': 'Note pour la boutique (facultatif)',
    'storefront.checkout.place': 'Confirmer la commande ({total})',
    'storefront.checkout.summary': 'Récapitulatif',
    'storefront.checkout.field.required': 'Ce champ est obligatoire.',
    'storefront.checkout.field.phone': 'Numéro de téléphone invalide.',
    'storefront.checkout.field.email': 'Adresse e-mail invalide.',
    'storefront.checkout.field.postalCode': 'Quatre chiffres.',
    'storefront.checkout.field.invalid': 'Valeur invalide.',
    'storefront.checkout.error.validation': 'Vérifiez les informations saisies.',
    'storefront.checkout.error.cart-changed': 'Certains articles ne sont plus disponibles. Vérifiez votre panier.',
    'storefront.checkout.error.discount-invalid': 'Le code promo ne peut plus être utilisé. Retirez-le de votre panier.',
    'storefront.checkout.error.checkout-unavailable': 'Ce choix n’est plus proposé par la boutique.',
    'storefront.checkout.error.insufficient-stock': 'Un article n’est plus disponible en quantité suffisante.',
    'storefront.checkout.error.too-many-requests': 'Trop de tentatives. Réessayez dans quelques minutes.',
    'storefront.checkout.error.generic': 'La commande n’a pas pu être passée. Réessayez.',
    'storefront.order.title': 'Merci pour votre commande !',
    'storefront.order.number': 'Commande n° {number}',
    'storefront.order.cashOnDelivery': 'Vous paierez à la livraison : préparez {total}.',
    'storefront.order.bankTransfer': 'Effectuez un virement de {total} :',
    'storefront.order.pickup': 'Retrait en magasin : la boutique vous contactera quand la commande sera prête.',
    'storefront.order.shippingTo': 'Livraison à :',
    'storefront.order.contact': 'La boutique vous contactera au {phone}.',
    'storefront.order.keep': 'Gardez l’adresse de cette page : elle vous permet de revoir votre commande.',
    'storefront.order.view': 'Voir ma commande',
    'storefront.order.notFound': 'Commande introuvable.',
    // --- module 11: order management, invoices ---
    'email.orderStatus.confirmed.subject': 'Commande n° {number} confirmée par {store}',
    'email.orderStatus.confirmed.heading': 'Votre commande est confirmée',
    'email.orderStatus.confirmed.intro': '{store} a confirmé votre commande n° {number} et la prépare.',
    'email.orderStatus.shipped.subject': 'Commande n° {number} expédiée – {store}',
    'email.orderStatus.shipped.heading': 'Votre commande est en route',
    'email.orderStatus.shipped.intro': '{store} a expédié votre commande n° {number}.',
    'email.orderStatus.delivered.subject': 'Commande n° {number} livrée – {store}',
    'email.orderStatus.delivered.heading': 'Votre commande est livrée',
    'email.orderStatus.delivered.intro': 'Votre commande n° {number} chez {store} est livrée. Merci !',
    'email.orderStatus.cancelled.subject': 'Commande n° {number} annulée – {store}',
    'email.orderStatus.cancelled.heading': 'Votre commande est annulée',
    'email.orderStatus.cancelled.intro': '{store} a annulé votre commande n° {number}. Contactez la boutique pour toute question.',
    'email.orderStatus.tracking': 'Suivi : {note}',
    'invoice.title': 'Facture',
    'invoice.number': 'N° {number}',
    'invoice.date': 'Date : {date}',
    'invoice.order': 'Commande n° {number} du {date}',
    'invoice.taxId': 'Identifiant fiscal : {taxId}',
    'invoice.billTo': 'Client',
    'invoice.payment': 'Paiement et livraison',
    'invoice.paymentMethod.cash_on_delivery': 'Paiement à la livraison',
    'invoice.paymentMethod.bank_transfer': 'Virement bancaire',
    'invoice.delivery.shipping': 'Livraison à domicile',
    'invoice.delivery.pickup': 'Retrait en magasin',
    'invoice.column.item': 'Désignation',
    'invoice.column.quantity': 'Qté',
    'invoice.column.unitPrice': 'Prix unitaire',
    'invoice.column.discount': 'Remise',
    'invoice.column.total': 'Montant',
    'invoice.subtotal': 'Sous-total',
    'invoice.discount': 'Remise',
    'invoice.discountCode': 'Remise ({code})',
    'invoice.shipping': 'Livraison',
    'invoice.fee': 'Frais',
    'invoice.tax': 'TVA',
    'invoice.taxIncluded': 'dont TVA',
    'invoice.taxLine': 'TVA {rate} % sur {net} : {tax}',
    'invoice.total': 'Total',
    'admin.inventory.reason.cancelled': 'Commande annulée',
    'admin.order.status': 'Statut',
    'admin.order.status.placed': 'Nouvelle',
    'admin.order.status.confirmed': 'Confirmée',
    'admin.order.status.shipped': 'Expédiée',
    'admin.order.status.delivered': 'Livrée',
    'admin.order.status.cancelled': 'Annulée',
    'admin.order.status.returned': 'Retournée',
    'admin.order.paymentStatus.refunded': 'Remboursée',
    'admin.order.filter.allStatuses': 'Tous les statuts',
    'admin.order.filter.allPayments': 'Tous les paiements',
    'admin.order.actions': 'Actions',
    'admin.order.noActions': 'Aucune action possible : la commande est terminée.',
    'admin.order.action.confirm': 'Confirmer la commande',
    'admin.order.action.ship': 'Marquer comme expédiée',
    'admin.order.action.deliver': 'Marquer comme livrée',
    'admin.order.action.cancel': 'Annuler la commande',
    'admin.order.action.return': 'Enregistrer un retour',
    'admin.order.action.mark-paid': 'Marquer comme payée',
    'admin.order.action.refund': 'Marquer comme remboursée',
    'admin.order.trackingNote': 'Suivi pour le client (facultatif)',
    'admin.order.trackingNoteHint': 'Transporteur, numéro de suivi… envoyé au client par e-mail.',
    'admin.order.actionNote': 'Note interne (facultatif)',
    'admin.order.cancelHint': 'Les articles suivis en stock sont remis en vente.',
    'admin.order.returnHint': 'Indiquez ce qui retourne en stock ; les articles abîmés restent hors stock.',
    'admin.order.restockOf': 'Remis en stock : {title}',
    'admin.order.apply': 'Valider',
    'admin.order.updated': 'Commande mise à jour.',
    'admin.order.error.invalid-transition': 'Ce changement n’est plus possible. Rechargez la page.',
    'admin.order.error.version-conflict': 'La commande a été modifiée entre-temps. Rechargez la page.',
    'admin.order.error.invoice-settings-missing': 'Renseignez d’abord la raison sociale et l’adresse dans la facturation.',
    'admin.order.error.invoice-exists': 'La facture existe déjà.',
    'admin.order.tracking': 'Suivi : {note}',
    'admin.order.history': 'Historique',
    'admin.order.history.placed': 'Commande passée',
    'admin.order.history.status': 'Statut : {from} → {to}',
    'admin.order.history.payment': 'Paiement : {from} → {to}',
    'admin.order.history.note': 'Note',
    'admin.order.history.invoice': 'Facture {number} émise',
    'admin.order.history.restocked': '{count, plural, one {# article remis en stock} other {# articles remis en stock}}',
    'admin.order.noteLabel': 'Note interne',
    'admin.order.addNote': 'Ajouter la note',
    'admin.order.noteAdded': 'Note ajoutée.',
    'admin.order.invoice': 'Facture',
    'admin.order.invoiceNone': 'Aucune facture émise.',
    'admin.order.invoiceLanguage': 'Langue de la facture',
    'admin.order.issueInvoice': 'Émettre la facture',
    'admin.order.invoiceIssued': 'Facture émise.',
    'admin.order.downloadInvoice': 'Télécharger la facture {number} (PDF)',
    'admin.invoice.title': 'Facturation',
    'admin.invoice.intro': 'Ces informations sont imprimées telles quelles sur vos factures. Vous êtes responsable de leur exactitude et des mentions obligatoires ; beinstore n’ajoute aucune mention légale.',
    'admin.invoice.legalNameIn': 'Raison sociale ({language})',
    'admin.invoice.addressIn': 'Adresse ({language})',
    'admin.invoice.taxId': 'Identifiant fiscal (facultatif)',
    'admin.invoice.footerIn': 'Texte de bas de page ({language}, facultatif)',
    'admin.invoice.prefix': 'Préfixe des numéros (facultatif)',
    'admin.invoice.prefixHint': 'Lettres, chiffres, / et - (12 au plus), par exemple FA-. Les numéros se suivent sans trou.',
    'admin.invoice.invalidPrefix': 'Préfixe invalide.',
    'admin.invoice.saved': 'Réglages de facturation enregistrés.',
    'admin.invoice.error.validation': 'Vérifiez les champs signalés.',
    'admin.invoice.error.version-conflict': 'Les réglages ont été modifiés entre-temps. Rechargez la page.',
    'storefront.order.status': 'Statut : {status}',
    'storefront.order.status.placed': 'Reçue, en attente de confirmation',
    'storefront.order.status.confirmed': 'Confirmée, en préparation',
    'storefront.order.status.shipped': 'Expédiée',
    'storefront.order.status.delivered': 'Livrée',
    'storefront.order.status.cancelled': 'Annulée',
    'storefront.order.status.returned': 'Retournée',
    'storefront.order.tracking': 'Suivi : {note}',
    // --- module 16: private apps and webhooks ---
    'admin.integrations.title': 'Applications et webhooks',
    'admin.integrations.intro': 'Connectez vos propres outils (ERP, logiciel de caisse, tableur) à votre boutique.',
    'admin.integrations.apps': 'Applications privées',
    'admin.integrations.appsIntro': 'Chaque application reçoit un jeton secret limité aux permissions choisies. Ne le confiez qu’à un prestataire de confiance.',
    'admin.integrations.appName': 'Nom de l’application',
    'admin.integrations.scopes': 'Permissions',
    'admin.integrations.scope.products.read': 'Lire les produits',
    'admin.integrations.scope.inventory.read': 'Lire le stock',
    'admin.integrations.scope.inventory.write': 'Mettre à jour le stock',
    'admin.integrations.scope.orders.read': 'Lire les commandes (avec les coordonnées des clients)',
    'admin.integrations.scope.orders.write': 'Traiter les commandes (confirmer, expédier, livrer, annuler)',
    'admin.integrations.createApp': 'Créer l’application',
    'admin.integrations.tokenTitle': 'Jeton de « {name} »',
    'admin.integrations.tokenWarning': 'Copiez ce jeton maintenant : il ne sera plus affiché. Envoyez-le dans l’en-tête Authorization: Bearer.',
    'admin.integrations.noApps': 'Aucune application.',
    'admin.integrations.column.name': 'Nom',
    'admin.integrations.column.scopes': 'Permissions',
    'admin.integrations.column.token': 'Jeton',
    'admin.integrations.column.lastUsed': 'Dernière utilisation',
    'admin.integrations.column.status': 'État',
    'admin.integrations.column.result': 'Résultat',
    'admin.integrations.never': 'Jamais',
    'admin.integrations.appStatus.active': 'Active',
    'admin.integrations.appStatus.revoked': 'Révoquée',
    'admin.integrations.revoke': 'Révoquer {name}',
    'admin.integrations.revoked': 'Application révoquée : son jeton ne fonctionne plus.',
    'admin.integrations.webhooks': 'Webhooks',
    'admin.integrations.webhooksIntro': 'beinstore envoie une requête POST signée à votre adresse pour chaque événement choisi. Vérifiez la signature avec le secret de l’adresse.',
    'admin.integrations.webhooksDisabled': 'Les webhooks ne sont pas encore configurés sur la plateforme.',
    'admin.integrations.url': 'Adresse de réception (https)',
    'admin.integrations.events': 'Événements',
    'admin.integrations.event.order.placed': 'Commande passée',
    'admin.integrations.event.order.status_changed': 'Statut de commande modifié',
    'admin.integrations.event.order.payment_changed': 'Paiement de commande modifié',
    'admin.integrations.event.product.created': 'Produit créé',
    'admin.integrations.event.product.updated': 'Produit modifié',
    'admin.integrations.event.product.deleted': 'Produit supprimé',
    'admin.integrations.event.inventory.availability_changed': 'Disponibilité modifiée',
    'admin.integrations.event.invoice.issued': 'Facture émise',
    'admin.integrations.addEndpoint': 'Ajouter l’adresse',
    'admin.integrations.noEndpoints': 'Aucune adresse.',
    'admin.integrations.endpointStatus.active': 'Active',
    'admin.integrations.endpointStatus.disabled': 'Désactivée',
    'admin.integrations.disabledByFailures': 'Désactivée après des échecs répétés',
    'admin.integrations.secret': 'Secret de signature',
    'admin.integrations.showSecret': 'Afficher le secret',
    'admin.integrations.rotateSecret': 'Changer le secret',
    'admin.integrations.rotated': 'Nouveau secret : l’ancien ne fonctionne plus.',
    'admin.integrations.ping': 'Envoyer un test',
    'admin.integrations.pinged': 'Test mis en file d’envoi.',
    'admin.integrations.disable': 'Désactiver',
    'admin.integrations.enable': 'Réactiver',
    'admin.integrations.delete': 'Supprimer',
    'admin.integrations.deliveries': 'Voir les envois',
    'admin.integrations.noDeliveries': 'Aucun envoi.',
    'admin.integrations.delivery.pending': 'En attente',
    'admin.integrations.delivery.succeeded': 'Réussi',
    'admin.integrations.delivery.failed': 'Échoué',
    'admin.integrations.attempts': '{count, plural, one {# essai} other {# essais}}',
    'admin.integrations.redeliver': 'Renvoyer',
    'admin.integrations.redelivered': 'Envoi remis en file.',
    'admin.integrations.error.app': 'Donnez un nom et au moins une permission.',
    'admin.integrations.error.endpoint': 'Donnez une adresse et au moins un événement.',
    'admin.integrations.error.url-scheme': 'Utilisez une adresse https.',
    'admin.integrations.error.url-credentials': 'L’adresse ne doit pas contenir d’identifiants.',
    'admin.integrations.error.url-address': 'Cette adresse n’est pas autorisée (réseau privé ou local).',
    'admin.integrations.error.url-invalid': 'Adresse invalide.',
    'admin.integrations.error.limit': 'Limite atteinte : supprimez ou révoquez d’abord un élément.',
    'admin.integrations.error.version-conflict': 'L’adresse a été modifiée entre-temps. Rechargez la page.',
    // --- module 17: analytics, customer data ---
    'admin.analytics.title': 'Statistiques',
    'admin.analytics.definition': 'Ventes = commandes ni annulées ni retournées (montant total, livraison et frais compris). Dates à l’heure de Tunis.',
    'admin.analytics.from': 'Du',
    'admin.analytics.to': 'Au',
    'admin.analytics.granularity': 'Regrouper par',
    'admin.analytics.granularity.day': 'Jour',
    'admin.analytics.granularity.week': 'Semaine',
    'admin.analytics.granularity.month': 'Mois',
    'admin.analytics.exportOrders': 'Exporter les commandes de la période (CSV)',
    'admin.analytics.revenue': 'Ventes',
    'admin.analytics.orders': 'Commandes',
    'admin.analytics.averageBasket': 'Panier moyen',
    'admin.analytics.change': '{percent} % par rapport à la période précédente',
    'admin.analytics.noComparison': 'Pas de période précédente à comparer',
    'admin.analytics.sales': 'Ventes par période',
    'admin.analytics.chartLabel': 'Ventes du {from} au {to} : {total}',
    'admin.analytics.showTable': 'Voir les chiffres',
    'admin.analytics.period': 'Période',
    'admin.analytics.topProducts': 'Meilleures ventes',
    'admin.analytics.noSales': 'Aucune vente sur la période.',
    'admin.analytics.byGovernorate': 'Ventes par gouvernorat',
    'admin.analytics.region': 'Gouvernorat',
    'admin.analytics.share': 'Part des commandes',
    'admin.analytics.funnel': 'Suivi des commandes',
    'admin.analytics.payments': 'Encaissements',
    'admin.analytics.range': 'Période',
    'admin.analytics.preset.7d': '7 derniers jours',
    'admin.analytics.preset.30d': '30 derniers jours',
    'admin.analytics.preset.90d': '90 derniers jours',
    'admin.analytics.preset.month': 'Ce mois-ci',
    'admin.analytics.itemsSold': 'Articles vendus',
    'admin.analytics.cancelled': 'Annulations',
    'admin.analytics.returned': 'Retours',
    'admin.analytics.outcomes': 'Commandes, annulations et retours',
    'admin.analytics.outcomesLabel': 'Commandes, annulations et retours du {from} au {to}',
    'admin.analytics.catalog': 'Catalogue',
    'admin.analytics.overview': 'Aperçu de la boutique',
    'admin.analytics.seeDashboard': 'Ouvrir le tableau de bord',
    'admin.privacy.title': 'Données des clients',
    'admin.privacy.intro': 'Répondez aux demandes de vos clients : retrouvez leurs commandes, exportez leurs données ou effacez-les. L’effacement retire nom, téléphone, e-mail, adresse et note ; les montants et les factures émises sont conservés.',
    'admin.privacy.identifier': 'Rechercher par',
    'admin.privacy.search': 'Rechercher',
    'admin.privacy.found': '{count, plural, =0 {Aucune commande avec des données de ce client.} one {# commande contient des données de ce client.} other {# commandes contiennent des données de ce client.}}',
    'admin.privacy.export': 'Exporter les données (JSON)',
    'admin.privacy.exported': 'Données exportées.',
    'admin.privacy.eraseHint': 'Les commandes doivent être livrées, annulées ou retournées avant l’effacement. L’action est définitive.',
    'admin.privacy.erase': 'Effacer les données',
    'admin.privacy.confirm': 'Je confirme l’effacement définitif des données personnelles de ce client',
    'admin.privacy.erased': '{count, plural, one {Données effacées de # commande.} other {Données effacées de # commandes.}}',
    'admin.privacy.log': 'Historique des demandes',
    'admin.privacy.noLog': 'Aucune demande.',
    'admin.privacy.kind.export': 'Export',
    'admin.privacy.kind.erase': 'Effacement',
    'admin.privacy.kind.retention': 'Durée de conservation',
    'admin.privacy.ordersAffected': '{count, plural, one {# commande} other {# commandes}}',
    'admin.privacy.error.inProgress': 'Des commandes sont encore en cours. {detail}',
    'admin.privacy.error.identifier': 'Numéro ou e-mail invalide.',
    'admin.privacy.erasedCustomer': 'Client effacé',
    'admin.privacy.erasedOn': 'Données du client effacées le {date}.',
    // --- module 14: cash-on-delivery management ---
    'email.order.respond': 'Confirmer ma commande',
    'email.order.view': 'Suivre ma commande',
    'email.order.respondHint': 'Merci de confirmer votre commande pour que la boutique la prépare.',
    'storefront.order.respondIntro': 'Paiement à la livraison : confirmez votre commande pour que la boutique la prépare.',
    'storefront.order.confirm': 'Je confirme ma commande',
    'storefront.order.cancel': 'Annuler ma commande',
    'storefront.order.confirmed': 'Merci, votre commande est confirmée.',
    'storefront.order.cancelled': 'Votre commande est annulée.',
    'storefront.order.actionFailed': 'Cette commande ne peut plus être modifiée ici.',
    'admin.cod.title': 'Paiement à la livraison',
    'admin.cod.intro': 'Confirmation des commandes, annulation automatique et numéros refusés.',
    'admin.cod.customerConfirmation': 'Le client confirme sa commande depuis la page de commande et l’e-mail ; il peut l’annuler après confirmation',
    'admin.cod.autoCancelHours': 'Annuler les commandes non confirmées après (heures)',
    'admin.cod.autoCancelHint': 'Laissez vide pour ne jamais annuler automatiquement. Le stock est remis et le client reçoit l’e-mail d’annulation.',
    'admin.cod.refusalThreshold': 'Signaler un numéro à partir de ce nombre de commandes retournées',
    'admin.cod.refusalHint': 'Calculé sur les commandes de votre boutique uniquement. Laissez vide pour ne rien signaler.',
    'admin.cod.saved': 'Réglages enregistrés.',
    'admin.cod.blocked.title': 'Numéros refusés au paiement à la livraison',
    'admin.cod.blocked.hint': 'Ces numéros ne peuvent plus choisir le paiement à la livraison dans votre boutique. Seuls les derniers chiffres sont conservés.',
    'admin.cod.blocked.none': 'Aucun numéro.',
    'admin.cod.blocked.entry': 'Numéro se terminant par {hint}',
    'admin.cod.blocked.phone': 'Numéro de téléphone',
    'admin.cod.blocked.reason': 'Motif (facultatif)',
    'admin.cod.blocked.add': 'Bloquer ce numéro',
    'admin.cod.blocked.remove': 'Débloquer le numéro se terminant par {hint}',
    'admin.cod.panel': 'Suivi du paiement à la livraison',
    'admin.cod.firstOrder': 'Première commande de ce numéro dans votre boutique.',
    'admin.cod.pastOrders': 'Autres commandes de ce numéro : {delivered} livrées, {returned} retournées, {cancelled} annulées, {inProgress} en cours.',
    'admin.cod.warning': 'Attention : {returned, plural, one {# commande retournée} other {# commandes retournées}} pour ce numéro.',
    'admin.cod.isBlocked': 'Ce numéro est refusé au paiement à la livraison.',
    'admin.cod.calls': '{count, plural, =0 {Aucun appel enregistré.} one {# appel enregistré.} other {# appels enregistrés.}}',
    'admin.cod.logCall': 'Enregistrer l’appel',
    'admin.cod.outcome': 'Résultat de l’appel',
    'admin.cod.outcome.confirmed': 'Confirmée par le client',
    'admin.cod.outcome.declined': 'Refusée par le client',
    'admin.cod.outcome.no_answer': 'Pas de réponse',
    'admin.cod.outcome.unreachable': 'Numéro injoignable ou erroné',
    'admin.cod.outcome.callback': 'À rappeler',
    'admin.cod.outcomeHint': '« Confirmée » confirme la commande ; « Refusée » l’annule et remet le stock.',
    'admin.cod.callNote': 'Note (facultatif)',
    'admin.cod.callLogged': 'Appel enregistré.',
    'admin.cod.block': 'Refuser ce numéro au paiement à la livraison',
    'admin.cod.unblock': 'Accepter à nouveau ce numéro',
    'admin.cod.blockedDone': 'Numéro refusé au paiement à la livraison.',
    'admin.cod.unblockedDone': 'Numéro accepté à nouveau.',
    'admin.cod.error.phone': 'Numéro de téléphone invalide.',
    'admin.cod.history.call': 'Appel : {outcome}',
    'admin.order.history.byCustomer': 'par le client',
    'admin.order.history.automatic': 'automatiquement',
    // --- module 13: shipping by settings ---
    'email.shipment.carrier': 'Transporteur : {carrier}',
    'email.shipment.line': '{carrier} — n° de suivi : {tracking}',
    'email.shipment.ownDelivery': 'Livraison par la boutique',
    'email.shipment.track': 'Suivre mon colis',
    'email.shipment.subject': 'Un autre colis de votre commande n° {number} est en route – {store}',
    'email.shipment.heading': 'Un autre colis est en route',
    'email.shipment.intro': '{store} a expédié une autre partie de votre commande n° {number}.',
    'deliveryNote.title': 'Bon de livraison',
    'deliveryNote.reference': 'Référence : {reference}',
    'deliveryNote.date': 'Date : {date}',
    'deliveryNote.recipient': 'Destinataire',
    'deliveryNote.carrier': 'Transporteur',
    'deliveryNote.ownDelivery': 'Livraison par la boutique',
    'deliveryNote.tracking': 'N° de suivi : {tracking}',
    'deliveryNote.collect': 'À encaisser à la livraison : {amount}',
    'deliveryNote.nothingToCollect': 'Rien à encaisser à la livraison',
    'deliveryNote.column.item': 'Article',
    'deliveryNote.column.quantity': 'Quantité',
    'deliveryNote.customerNote': 'Note du client',
    'storefront.order.shipments': 'Colis',
    'storefront.order.shipment': 'Colis {number}',
    'storefront.order.shipment.shipped': 'en route',
    'storefront.order.shipment.delivered': 'livré',
    'storefront.order.shipment.returned': 'retourné',
    'storefront.order.shipment.ownDelivery': 'Livraison par la boutique',
    'storefront.order.shipment.tracking': 'N° de suivi : {tracking}',
    'storefront.order.shipment.track': 'Suivre le colis {number}',
    'admin.carriers.title': 'Transporteurs',
    'admin.carriers.intro': 'Les transporteurs avec lesquels vous travaillez. Aucune connexion à leurs systèmes : vous saisissez le numéro de suivi à l’expédition.',
    'admin.carriers.none': 'Aucun transporteur.',
    'admin.carriers.name': 'Nom',
    'admin.carriers.phone': 'Téléphone (facultatif)',
    'admin.carriers.trackingUrl': 'Adresse de suivi (facultatif)',
    'admin.carriers.trackingUrlHint': 'Commence par https:// et contient {placeholder}, remplacé par le numéro de suivi.',
    'admin.carriers.defaultFee': 'Frais habituels par colis (DT, facultatif)',
    'admin.carriers.active': 'Proposer ce transporteur à l’expédition',
    'admin.carriers.add': 'Ajouter le transporteur',
    'admin.carriers.edit': 'Modifier {name}',
    'admin.carriers.added': 'Transporteur ajouté.',
    'admin.carriers.saved': 'Transporteur enregistré.',
    'admin.carriers.inactive': 'désactivé',
    'admin.carriers.error.conflict': 'Un transporteur porte déjà ce nom (ou la limite est atteinte).',
    'admin.carriers.error.validation': 'Vérifiez le nom, le téléphone, l’adresse de suivi et les frais.',
    'admin.shipment.title': 'Colis',
    'admin.shipment.none': 'Aucun colis envoyé.',
    'admin.shipment.number': 'Colis {number}',
    'admin.shipment.ownDelivery': 'Livraison par la boutique',
    'admin.shipment.status.shipped': 'En route',
    'admin.shipment.status.delivered': 'Livré',
    'admin.shipment.status.returned': 'Retourné',
    'admin.shipment.tracking': 'Suivi : {tracking}',
    'admin.shipment.cod': 'À encaisser : {amount}',
    'admin.shipment.fee': 'Frais transporteur : {amount}',
    'admin.shipment.items': '{count, plural, one {# article} other {# articles}}',
    'admin.shipment.markDelivered': 'Marquer le colis {number} comme livré',
    'admin.shipment.markReturned': 'Marquer le colis {number} comme retourné',
    'admin.shipment.note': 'Bon de livraison du colis {number} ({language})',
    'admin.shipment.new': 'Expédier un colis',
    'admin.shipment.quantity': 'Quantité à expédier : {item}',
    'admin.shipment.left': 'reste {count}',
    'admin.shipment.carrier': 'Transporteur',
    'admin.shipment.trackingNumber': 'Numéro de suivi (facultatif)',
    'admin.shipment.feeLabel': 'Frais du transporteur (DT, facultatif)',
    'admin.shipment.feeHint': 'Vide : frais habituels du transporteur.',
    'admin.shipment.codLabel': 'À encaisser à la livraison (DT, facultatif)',
    'admin.shipment.codHint': 'Vide : tout le reste à encaisser.',
    'admin.shipment.create': 'Expédier',
    'admin.shipment.created': 'Colis enregistré.',
    'admin.shipment.updated': 'Colis mis à jour.',
    'admin.shipment.error.validation': 'Vérifiez les quantités (pas plus que le reste à expédier), le numéro de suivi et les montants (pas plus que le reste à encaisser).',
    'admin.shipment.error.empty': 'Choisissez au moins un article.',
    'admin.order.history.shipment': 'Colis {number} : {status}',
    // --- module 12: cash-on-delivery payments ---
    'admin.cash.title': 'Encaissements',
    'admin.cash.total': 'Total de la commande : {amount}',
    'admin.cash.collected': 'Encaissé : {amount}',
    'admin.cash.refunded': 'Remboursé : {amount}',
    'admin.cash.due': 'Reste à encaisser : {amount}',
    'admin.cash.none': 'Aucun encaissement.',
    'admin.cash.kind.collection': 'Encaissement',
    'admin.cash.kind.refund': 'Remboursement',
    'admin.cash.kind.reversal': 'Annulation',
    'admin.cash.byCarrier': 'par {carrier}',
    'admin.cash.byMerchant': 'par la boutique',
    'admin.cash.parcel': 'colis {number}',
    'admin.cash.automatic': 'automatique',
    'admin.cash.reversed': 'annulé',
    'admin.cash.remitted': 'reversé par le transporteur',
    'admin.cash.reverse': 'Annuler l’écriture du {date}',
    'admin.cash.reversedDone': 'Écriture annulée.',
    'admin.cash.collect': 'Enregistrer un encaissement',
    'admin.cash.amount': 'Montant (DT)',
    'admin.cash.collector': 'Encaissé par',
    'admin.cash.merchant': 'La boutique',
    'admin.cash.note': 'Note (facultatif)',
    'admin.cash.collectedDone': 'Encaissement enregistré.',
    'admin.cash.refund': 'Enregistrer un remboursement',
    'admin.cash.refundedDone': 'Remboursement enregistré.',
    'admin.cash.error.amount': 'Montant invalide : pas plus que le reste à encaisser (ou que ce qui a été encaissé, pour un remboursement).',
    'admin.cash.error.reverse': 'Cette écriture ne peut pas être annulée (déjà annulée, ou argent déjà reversé par le transporteur : enregistrez un remboursement).',
    'admin.payments.title': 'Encaissements et transporteurs',
    'admin.payments.intro': 'Paiement à la livraison : l’argent encaissé par les transporteurs vous est reversé, leurs frais déduits.',
    'admin.payments.inHand': 'En caisse : {amount}',
    'admin.payments.withCarriers': 'Chez les transporteurs : {amount}',
    'admin.payments.owed': '{name} vous doit {amount} ({count, plural, one {# encaissement} other {# encaissements}})',
    'admin.payments.lastRemittance': 'Dernier versement : {date}',
    'admin.payments.remit': 'Enregistrer un versement de {name}',
    'admin.payments.order': 'Commande n° {number}',
    'admin.payments.fees': 'Frais retenus par le transporteur (DT)',
    'admin.payments.feesHint': 'Proposé : frais des colis ({amount}).',
    'admin.payments.receivedAt': 'Date du versement',
    'admin.payments.net': 'Montant reçu : {amount}',
    'admin.payments.save': 'Enregistrer le versement',
    'admin.payments.saved': 'Versement enregistré.',
    'admin.payments.history': 'Versements',
    'admin.payments.remittance': '{date} — {name} : {net} reçus ({gross} encaissés, {fees} de frais)',
    'admin.payments.none': 'Aucun versement.',
    'admin.payments.nothingOwed': 'Rien en attente chez ce transporteur.',
    'admin.payments.error.select': 'Choisissez au moins un encaissement.',
    'admin.payments.error.stale': 'Ces encaissements ne sont plus en attente : rechargez la page.',
    // --- module 15: billing, custom domains, operator console ---
    'platformInvoice.title': 'Facture',
    'platformInvoice.taxId': 'Matricule fiscal : {taxId}',
    'platformInvoice.number': 'N° {number}',
    'platformInvoice.date': 'Date : {date}',
    'platformInvoice.billTo': 'Facturé à',
    'platformInvoice.column.description': 'Désignation',
    'platformInvoice.column.amount': 'Montant',
    'platformInvoice.line': 'Abonnement {plan} — {months} mois, du {from} au {to}',
    'platformInvoice.net': 'Total hors TVA',
    'platformInvoice.vat': 'TVA {rate} %',
    'platformInvoice.total': 'Total',
    'platformInvoice.paid': 'Payé par {method} le {date}',
    'platformInvoice.method.bank_transfer': 'virement bancaire',
    'platformInvoice.method.cash': 'espèces',
    'platformInvoice.method.other': 'autre moyen',
    'platformInvoice.reference': 'Référence : {reference}',
    'admin.error.subscription-restricted': 'Abonnement impayé : seules les commandes peuvent être modifiées jusqu’au paiement.',
    'admin.error.plan-limit-reached': 'Limite de votre forfait atteinte : passez à un forfait supérieur pour en ajouter.',
    'admin.billing.title': 'Abonnement',
    'admin.billing.none': 'Votre boutique n’a pas de forfait pour l’instant.',
    'admin.billing.plan': 'Forfait : {name}',
    'admin.billing.price': '{amount} tous les {months, plural, one {# mois} other {# mois}}',
    'admin.billing.state.none': 'Sans abonnement.',
    'admin.billing.state.free': 'Forfait gratuit.',
    'admin.billing.state.trialing': 'Essai gratuit jusqu’au {date}.',
    'admin.billing.state.active': 'Payé jusqu’au {date}.',
    'admin.billing.state.grace': 'Paiement en retard : l’administration passera en lecture seule le {date} (les commandes continuent de fonctionner).',
    'admin.billing.state.restricted': 'Abonnement impayé : l’administration est en lecture seule, sauf les commandes, jusqu’au paiement.',
    'admin.billing.howToPay': 'Les paiements sont enregistrés par l’équipe beinstore ; la facture apparaît ensuite ici.',
    'admin.billing.usage': 'Utilisation',
    'admin.billing.kind.products': 'Produits',
    'admin.billing.kind.staff': 'Membres de l’équipe',
    'admin.billing.kind.customDomains': 'Domaines personnalisés',
    'admin.billing.usageLine': '{kind} : {used} / {limit}',
    'admin.billing.usageUnlimited': '{kind} : {used} (illimité)',
    'admin.billing.invoices': 'Factures beinstore',
    'admin.billing.noInvoices': 'Aucune facture.',
    'admin.billing.invoice': 'Facture {number} du {date} — {amount} (PDF)',
    'admin.billing.details': 'Voir l’abonnement',
    'admin.domains.title': 'Adresses de la boutique',
    'admin.domains.intro': 'Votre boutique reste toujours accessible à son adresse beinstore. Vous pouvez aussi utiliser votre propre nom de domaine.',
    'admin.domains.unavailable': 'Les domaines personnalisés ne sont pas encore disponibles sur la plateforme.',
    'admin.domains.kind.platform_subdomain': 'Adresse beinstore',
    'admin.domains.kind.custom': 'Domaine personnalisé',
    'admin.domains.status.pending_verification': 'en attente de vérification',
    'admin.domains.status.active': 'actif',
    'admin.domains.canonical': 'adresse principale',
    'admin.domains.host': 'Nom de domaine (ex. boutique.example.tn)',
    'admin.domains.add': 'Ajouter le domaine',
    'admin.domains.added': 'Domaine ajouté : créez les enregistrements DNS, puis vérifiez.',
    'admin.domains.instructions': 'Créez ces enregistrements chez votre fournisseur de domaine :',
    'admin.domains.txt': 'TXT {name} = {value}',
    'admin.domains.cname': 'CNAME {name} → {target}',
    'admin.domains.verify': 'Vérifier {host}',
    'admin.domains.verified': 'Domaine vérifié.',
    'admin.domains.makeCanonical': 'Utiliser {host} comme adresse principale',
    'admin.domains.canonicalDone': 'Adresse principale modifiée.',
    'admin.domains.remove': 'Retirer {host}',
    'admin.domains.removed': 'Domaine retiré.',
    'admin.domains.error.notVerified': 'Enregistrement de vérification introuvable. Les changements DNS peuvent prendre du temps.',
    'admin.domains.error.invalid': 'Nom de domaine invalide (il doit être en dehors du domaine de la plateforme).',
    'admin.domains.error.taken': 'Ce domaine est déjà utilisé.',
    'admin.nav.operator': 'Console opérateur',
    'admin.operator.title': 'Console opérateur',
    'admin.operator.stores': 'Boutiques',
    'admin.operator.plans': 'Forfaits',
    'admin.operator.settings': 'Paramètres de facturation',
    'admin.console.tagline': 'Forfaits, abonnements et factures de toutes les boutiques beinstore.',
    'admin.console.note': 'Réservé aux opérateurs de la plateforme beinstore.',
    'admin.landing.title': 'Page d’accueil',
    'admin.landing.intro': 'Les textes de la page publique beinstore.tn. Les forfaits sont ceux proposés à l’inscription. Les éléments vides ne sont pas affichés.',
    'admin.landing.language': 'Langue en cours de modification',
    'admin.landing.features': 'Fonctionnalités',
    'admin.landing.feature': 'Fonctionnalité {number}',
    'admin.landing.featureTitle': 'Titre ({language})',
    'admin.landing.featureText': 'Texte ({language})',
    'admin.landing.addFeature': 'Ajouter une fonctionnalité',
    'admin.landing.faq': 'Questions et réponses',
    'admin.landing.question': 'Question {number}',
    'admin.landing.questionText': 'Question ({language})',
    'admin.landing.answer': 'Réponse ({language})',
    'admin.landing.addQuestion': 'Ajouter une question',
    'admin.landing.remove': 'Retirer',
    'admin.landing.links': 'Pages légales',
    'admin.landing.terms': 'Conditions d’utilisation (adresse)',
    'admin.landing.privacy': 'Politique de confidentialité (adresse)',
    'admin.landing.linkHint': 'Une adresse https d’une page que vous hébergez. Vide = pas de lien.',
    'admin.landing.saved': 'Page d’accueil enregistrée.',
    'admin.landing.invalid': 'Vérifiez les textes et les adresses (https uniquement).',
    'landing.title': 'beinstore — votre boutique en ligne en Tunisie',
    'landing.skip': 'Aller au contenu',
    'landing.language': 'Langue',
    'landing.signIn': 'Se connecter',
    'landing.cta': 'Créer ma boutique',
    'landing.compare': 'Comparer les forfaits',
    'landing.plans': 'Forfaits',
    'landing.noPlans': 'Aucun forfait n’est disponible pour le moment.',
    'landing.choose': 'Choisir ce forfait',
    'landing.chooseNamed': 'Choisir le forfait {name}',
    'landing.free': 'Gratuit',
    'landing.price': '{amount} tous les {months, plural, one {mois} other {# mois}}',
    'landing.trial': '{days, plural, one {# jour} other {# jours}} d’essai gratuit',
    'landing.limit.products': 'Produits : {count}',
    'landing.limit.staff': 'Membres de l’équipe : {count}',
    'landing.limit.domains': 'Domaines personnalisés : {count}',
    'landing.unlimited': 'illimité',
    'landing.features': 'Fonctionnalités',
    'landing.faq': 'Questions et réponses',
    'landing.terms': 'Conditions d’utilisation',
    'landing.privacy': 'Politique de confidentialité',
    'landing.error': 'La page n’a pas pu être chargée. Réessayez dans un instant.',
    'landing.menu': 'Sur cette page',
    'landing.vision.title': 'Vision',
    'landing.vision.body': 'Chaque boutique en Tunisie doit pouvoir prendre une commande, la livrer et encaisser au même endroit, dans la langue que le client lit vraiment.',
    'landing.about.title': 'À propos',
    'landing.about.body': 'beinstore est cette plateforme. Le marchand ouvre une boutique, choisit un forfait et vend. Le client commande, paie à la livraison ou par virement, et suit sa commande. La boutique parle arabe, français, tunisien et anglais.',
    'landing.about.merchantTitle': 'Le marchand',
    'landing.about.merchant': 'Le marchand ouvre une boutique, choisit un forfait et vend.',
    'landing.about.customerTitle': 'Le client',
    'landing.about.customer': 'Le client commande, paie à la livraison ou par virement, et suit sa commande.',
    'landing.about.languagesTitle': 'Quatre langues',
    'landing.about.languages': 'La boutique parle arabe, français, tunisien et anglais.',
    'landing.contact.title': 'Contact',
    'landing.contact.body': 'Une question sur un forfait ou une boutique : écrivez-nous. Un marchand qui a déjà une boutique se connecte.',
    'landing.contact.write': 'Écrivez-nous',
    'landing.legal.title': 'Politiques',
    'landing.legal.termsBody': 'Le marchand choisit un forfait, puis utilise beinstore pour une boutique. Le prix et l’essai sont ceux affichés sur cette page.',
    'landing.legal.privacyBody': 'Nous utilisons les informations de connexion d’un marchand pour faire tourner sa boutique, et les détails d’une commande pour la livrer. Nous ne vendons pas ces informations.',
    'landing.legal.addressLabel': 'Adresse de la politique',
    'landing.footer.product': 'Le produit',
    'landing.place': 'Tunisie',
    'admin.setup.title': 'Configurez votre boutique',
    'admin.setup.progress': 'Étape {current} sur {total}',
    'admin.setup.steps': 'Étapes',
    'admin.setup.done': 'Fait',
    'admin.setup.todo': 'À faire',
    'admin.setup.optional': 'Facultatif',
    'admin.setup.required': 'Obligatoire',
    'admin.setup.skip': 'Passer cette étape',
    'admin.setup.continue': 'Continuer',
    'admin.setup.saveContinue': 'Enregistrer et continuer',
    'admin.setup.banner': 'Cette boutique n’est pas encore publiée : les clients ne la voient pas.',
    'admin.setup.finish': 'Terminer la configuration',
    'admin.setup.step.plan': 'Forfait',
    'admin.setup.step.contact': 'Coordonnées',
    'admin.setup.step.legal': 'Informations légales',
    'admin.setup.step.delivery': 'Livraison et paiement',
    'admin.setup.step.products': 'Produits',
    'admin.setup.step.publish': 'Publier',
    'admin.setup.plan.title': 'Choisissez votre forfait',
    'admin.setup.plan.none': 'Aucun forfait à choisir pour le moment : continuez.',
    'admin.setup.plan.free': 'Gratuit',
    'admin.setup.plan.trial': '{days, plural, one {# jour} other {# jours}} d’essai gratuit',
    'admin.setup.plan.limits': 'Produits : {products} · Membres de l’équipe : {staff}',
    'admin.setup.plan.unlimited': 'illimité',
    'admin.setup.plan.locked': 'La boutique est publiée ou déjà payée : contactez beinstore pour changer de forfait.',
    'admin.setup.contact.title': 'Comment les clients vous joignent',
    'admin.setup.contact.intro': 'Affiché en bas de chaque page de votre boutique.',
    'admin.setup.contact.phone': 'Téléphone',
    'admin.setup.contact.email': 'E-mail de contact',
    'admin.setup.contact.governorate': 'Gouvernorat',
    'admin.setup.contact.choose': 'Choisir…',
    'admin.setup.contact.address': 'Adresse (facultatif)',
    'admin.setup.contact.governorateMissing': 'Choisissez votre gouvernorat.',
    'admin.setup.legal.title': 'Vos informations légales',
    'admin.setup.legal.intro': 'Imprimées sur les factures que vous remettez à vos clients.',
    'admin.setup.legal.name': 'Raison sociale ({language})',
    'admin.setup.legal.address': 'Adresse du siège ({language})',
    'admin.setup.legal.taxId': 'Matricule fiscal',
    'admin.setup.legal.taxIdHint': 'Facultatif si vous n’êtes pas immatriculé.',
    'admin.setup.legal.more': 'Tous les réglages de facturation',
    'admin.setup.delivery.title': 'Comment vos clients paient et reçoivent leurs commandes',
    'admin.setup.delivery.intro': 'Il faut au moins un moyen de paiement et un mode de livraison pour recevoir des commandes.',
    'admin.setup.delivery.incomplete': 'Choisissez au moins un moyen de paiement, et le retrait en boutique ou des zones de livraison.',
    'admin.setup.delivery.bankInstructions': 'Instructions pour le virement',
    'admin.setup.delivery.shipping': 'Livraison à domicile',
    'admin.setup.delivery.zones': '{count, plural, =0 {Aucune zone de livraison pour l’instant.} one {# zone de livraison.} other {# zones de livraison.}}',
    'admin.setup.delivery.zonesLink': 'Définir les zones et tarifs de livraison par gouvernorat',
    'admin.setup.delivery.pickupAddress': 'Adresse de retrait',
    'admin.setup.products.title': 'Ajoutez vos premiers produits',
    'admin.setup.products.intro': 'Il faut au moins un produit en vente, avec un prix et du stock, pour publier.',
    'admin.setup.products.ready': 'Vous avez un produit prêt à la vente.',
    'admin.setup.products.added': 'Produits ajoutés',
    'admin.setup.products.form': 'Nouveau produit',
    'admin.setup.products.name': 'Nom',
    'admin.setup.products.price': 'Prix (TND)',
    'admin.setup.products.stock': 'Quantité en stock',
    'admin.setup.products.photo': 'Photo (facultatif)',
    'admin.setup.products.add': 'Ajouter le produit',
    'admin.setup.products.more': 'Éditeur complet des produits',
    'admin.setup.products.invalid': 'Saisissez un nom et un prix supérieur à zéro.',
    'admin.setup.publish.title': 'Publiez votre boutique',
    'admin.setup.publish.intro': 'Vérifiez-la avec l’aperçu, puis publiez : les clients pourront la visiter et commander.',
    'admin.setup.publish.missing': '{count, plural, one {Une étape obligatoire n’est pas faite.} other {# étapes obligatoires ne sont pas faites.}}',
    'admin.setup.publish.preview': 'Aperçu de la boutique',
    'admin.setup.publish.action': 'Publier ma boutique',
    'admin.setup.publish.online': 'Votre boutique est en ligne.',
    'admin.setup.publish.toStore': 'Aller au tableau de bord de la boutique',
    'admin.setup.publish.policies': 'Vous êtes le vendeur. Les produits interdits ne sont pas autorisés. beinstore peut masquer une annonce ou mettre la boutique hors ligne.',
    'admin.setup.publish.accept': 'J’ai lu et j’accepte les conditions d’utilisation et la politique de confidentialité',
    'admin.billing.paymentInstructions': 'Comment payer',
    'admin.operator.plan.offered': 'Inscription',
    'admin.operator.plan.offeredHint': 'Proposé aux nouveaux marchands dans l’assistant de configuration',
    'admin.operator.set.paymentInstructionsIn': 'Instructions de paiement pour les marchands ({language})',
    'admin.operator.set.paymentInstructionsHint': 'Par ex. les coordonnées bancaires de beinstore. Affichées à l’étape du forfait et sur la page d’abonnement.',
    'admin.operator.set.requiredSteps': 'Étapes obligatoires avant qu’une nouvelle boutique puisse être publiée',
    'admin.error.onboarding-incomplete': 'Certaines étapes obligatoires ne sont pas encore faites.',
    'admin.error.terms-not-accepted': 'Acceptez les conditions d’utilisation avant de publier.',
    'storefront.contact': 'Contact',
    'admin.error.operator-account': 'Ce compte est un compte opérateur de la plateforme. Connectez-vous sur la console opérateur.',
    'admin.error.merchant-account': 'Ce compte appartient à des boutiques. Les opérateurs de la plateforme ont besoin d’un compte dédié.',
    'admin.operator.search': 'Rechercher une boutique',
    'admin.operator.noStores': 'Aucune boutique.',
    'admin.operator.stores.intro': 'Chaque boutique et son forfait : dernier paiement, renouvellement et échéance. Recherche, filtres et tri.',
    'admin.operator.planFilter': 'Forfait',
    'admin.operator.plan.any': 'Tous les forfaits',
    'admin.operator.stateFilter': 'Abonnement',
    'admin.operator.state.any': 'Tous les statuts',
    'admin.operator.renew': 'Renouvellement',
    'admin.operator.deadline': 'Échéance',
    'admin.operator.lastPayment': 'Dernier paiement',
    'admin.operator.noPayment': 'Aucun',
    'admin.operator.noPlan': 'Sans forfait',
    'admin.operator.stateShort.none': 'Sans abonnement',
    'admin.operator.stateShort.free': 'Gratuit',
    'admin.operator.stateShort.trialing': 'Essai',
    'admin.operator.stateShort.active': 'À jour',
    'admin.operator.stateShort.grace': 'En retard',
    'admin.operator.stateShort.restricted': 'Restreint',
    'admin.operator.plan.new': 'Nouveau forfait',
    'admin.operator.plan.edit': 'Modifier {code}',
    'admin.operator.plan.code': 'Code',
    'admin.operator.plan.nameIn': 'Nom en {language}',
    'admin.operator.plan.price': 'Prix par période (DT)',
    'admin.operator.plan.period': 'Période',
    'admin.operator.plan.months': '{count, plural, one {# mois} other {# mois}}',
    'admin.operator.plan.trialDays': 'Jours d’essai gratuit',
    'admin.operator.plan.graceDays': 'Jours de grâce après l’échéance',
    'admin.operator.plan.maxProducts': 'Produits maximum (vide = illimité)',
    'admin.operator.plan.maxStaff': 'Membres d’équipe maximum (vide = illimité)',
    'admin.operator.plan.maxDomains': 'Domaines personnalisés maximum (vide = illimité)',
    'admin.operator.plan.active': 'Proposé aux boutiques',
    'admin.operator.plan.create': 'Créer le forfait',
    'admin.operator.plan.saved': 'Forfait enregistré.',
    'admin.operator.plan.error': 'Vérifiez le code (unique), le nom, le prix et les valeurs.',
    'admin.operator.plan.empty': 'Aucun forfait.',
    'admin.operator.plan.subscribers': 'Boutiques abonnées',
    'admin.operator.plan.subscriberCount': '{count, plural, one {# boutique} other {# boutiques}}',
    'admin.operator.plan.delete': 'Supprimer ce forfait',
    'admin.operator.plan.confirmDelete': 'Confirmer la suppression du forfait',
    'admin.operator.plan.deleted': 'Forfait supprimé.',
    'admin.operator.plan.cannotDelete.subscribers': 'Des boutiques sont encore sur ce forfait. Affectez-leur un autre forfait d’abord.',
    'admin.operator.plan.cannotDelete.payments': 'Des paiements ont été enregistrés sur ce forfait. Retirez-le de l’offre plutôt que de le supprimer.',
    'admin.operator.plan.cannotDelete.default': 'C’est le forfait des nouvelles boutiques. Changez-le dans les paramètres de facturation d’abord.',
    'admin.operator.set.legalNameIn': 'Raison sociale de beinstore ({language})',
    'admin.operator.set.addressIn': 'Adresse de beinstore ({language})',
    'admin.operator.set.taxId': 'Matricule fiscal de beinstore (facultatif)',
    'admin.operator.set.footerIn': 'Pied de facture ({language}, facultatif)',
    'admin.operator.set.prefix': 'Préfixe des numéros de facture',
    'admin.operator.set.vatRate': 'Taux de TVA en % (vide = pas de TVA)',
    'admin.operator.set.pricesIncludeVat': 'Les prix des forfaits incluent la TVA',
    'admin.operator.set.defaultPlan': 'Forfait des nouvelles boutiques',
    'admin.operator.set.noDefault': 'Aucun (pas d’abonnement)',
    'admin.operator.set.saved': 'Paramètres enregistrés.',
    'admin.operator.assign': 'Appliquer le forfait',
    'admin.operator.assigned': 'Forfait appliqué.',
    'admin.operator.payment': 'Enregistrer un paiement',
    'admin.operator.periods': 'Nombre de périodes',
    'admin.operator.amount': 'Montant (DT, vide = prix × périodes)',
    'admin.operator.method': 'Mode de paiement',
    'admin.operator.method.bank_transfer': 'Virement bancaire',
    'admin.operator.method.cash': 'Espèces',
    'admin.operator.method.other': 'Autre',
    'admin.operator.reference': 'Référence (facultatif)',
    'admin.operator.receivedAt': 'Date de réception',
    'admin.operator.invoiceLanguage': 'Langue de la facture',
    'admin.operator.paid': 'Paiement enregistré, facture émise.',
    'admin.operator.payments': 'Paiements',
    'admin.operator.noPayments': 'Aucun paiement.',
    'admin.operator.paymentLine': '{date} — {amount} — {periods, plural, one {# période} other {# périodes}} ({from} → {to})',
    'admin.operator.error.settings': 'Renseignez d’abord la raison sociale et l’adresse de beinstore dans les paramètres de facturation.',
    'admin.operator.error.noPlan': 'Appliquez d’abord un forfait à cette boutique.',
    'email.shopperCode.subject': 'Votre code {store} : {code}',
    'email.shopperCode.heading': 'Votre code de connexion',
    'email.shopperCode.intro': 'Utilisez ce code pour accéder à votre compte chez {store} :',
    'email.shopperCode.expiry': 'Il expire dans {minutes, plural, one {# minute} other {# minutes}} et ne peut être utilisé qu’une seule fois.',
    'email.shopperCode.ignore': 'Si vous n’êtes pas à l’origine de cette demande, ignorez cet e-mail : personne ne peut se connecter sans ce code.',
    'storefront.account.nav': 'Mon compte',
    'storefront.account.signIn': 'Connexion',
    'storefront.account.title': 'Mon compte',
    'storefront.account.orders': 'Mes commandes',
    'storefront.account.addresses': 'Mes adresses',
    'storefront.account.profile': 'Mes informations',
    'storefront.account.signOut': 'Se déconnecter',
    'storefront.account.phone': 'Téléphone',
    'storefront.account.email': 'E-mail',
    'storefront.account.name': 'Nom et prénom',
    'storefront.account.sendCode': 'Recevoir un code',
    'storefront.account.code': 'Code reçu par e-mail',
    'storefront.account.verify': 'Valider',
    'storefront.account.sent': 'Si ce numéro peut recevoir un code, il a été envoyé par e-mail.',
    'storefront.account.invalidCode': 'Code incorrect ou expiré.',
    'storefront.account.save': 'Enregistrer',
    'storefront.account.saved': 'Enregistré.',
    'storefront.account.emailChange': 'Changer d’e-mail',
    'storefront.account.emailHint': 'Un code est envoyé à la nouvelle adresse.',
    'storefront.account.noOrders': 'Aucune commande pour le moment.',
    'storefront.account.addAddress': 'Ajouter une adresse',
    'storefront.account.saveAddress': 'Enregistrer l’adresse',
    'storefront.account.removeAddress': 'Supprimer',
    'storefront.account.defaultAddress': 'Adresse par défaut',
    'storefront.account.makeDefault': 'Utiliser par défaut',
    'storefront.account.addressLimit': 'Dix adresses au maximum.',
    'storefront.account.cancelOrder': 'Annuler cette commande',
    'storefront.account.returnRequest': 'Demander un retour',
    'storefront.account.returnMessage': 'Que souhaitez-vous retourner ?',
    'storefront.account.returnSend': 'Envoyer la demande',
    'storefront.account.returnStatus.requested': 'Demande envoyée, en attente de la boutique',
    'storefront.account.returnStatus.accepted': 'Retour accepté',
    'storefront.account.returnStatus.declined': 'Demande refusée',
    'storefront.account.cancelClosed': 'Cette commande ne peut plus être annulée.',
    'storefront.account.phoneLocked': 'Le numéro de téléphone ne change pas.',
    'storefront.account.newAccount': 'Première visite : indiquez aussi votre nom et votre e-mail.',
    'storefront.account.back': 'Retour à mes commandes',
    'storefront.account.cancelled': 'Votre commande est annulée.',
    'storefront.account.returnSent': 'Votre demande a été envoyée.',
    'storefront.account.declineNote': 'Note de la boutique : {note}',
    'storefront.account.error': 'Cette action n’a pas abouti. Réessayez.',
    'storefront.account.ordered': 'Commandée',
    'storefront.account.payment': 'Paiement',
    'storefront.account.delivery': 'Livraison',
    'storefront.account.deliveryDate': 'Date de livraison',
    'storefront.account.plannedDelivery': 'Livraison prévue',
    'storefront.account.notDelivered': 'Pas encore livrée',
    'storefront.account.notScheduled': 'Date non indiquée',
    'storefront.account.homeDelivery': 'Livraison à domicile — {place}',
    'storefront.account.pickup': 'Retrait en boutique',
    'storefront.account.track': 'Suivi de la commande',
    'storefront.account.step.placed': 'Reçue',
    'storefront.account.step.confirmed': 'Confirmée',
    'storefront.account.step.shipped': 'Expédiée',
    'storefront.account.step.delivered': 'Livrée',
    'storefront.account.step.cancelled': 'Annulée',
    'storefront.account.step.returned': 'Retournée',
    'storefront.account.items': 'Articles',
    'storefront.account.payment.pending': 'En attente',
    'storefront.account.payment.paid': 'Payée',
    'storefront.account.payment.refunded': 'Remboursée',
    'storefront.account.returnStep.reason': 'Motif',
    'storefront.account.returnStep.items': 'Articles',
    'storefront.account.returnStep.details': 'Précisez pour la boutique',
    'storefront.account.returnReason.damaged': 'Article abîmé ou non conforme',
    'storefront.account.returnReason.wrong': 'Mauvais article',
    'storefront.account.returnReason.mind': 'J’ai changé d’avis',
    'storefront.account.returnReason.other': 'Autre motif',
    'storefront.account.returnWhole': 'Toute la commande',
    'storefront.account.returnReasonLabel': 'Motif',
    'storefront.account.returnItemsLabel': 'Articles',
    'storefront.account.commentTitle': 'Un message sur cette commande',
    'storefront.account.commentHint': 'Seule la boutique le voit. Il n’est pas publié.',
    'storefront.account.commentSend': 'Envoyer le message',
    'storefront.account.commentSent': 'Votre message a été envoyé à la boutique.',
    'admin.order.returnRequest': 'Demande de retour',
    'admin.order.returnRequest.none': 'Aucune demande de retour.',
    'admin.order.returnRequest.acceptHint': 'Enregistrer un retour accepte cette demande.',
    'admin.order.returnRequest.decline': 'Refuser la demande',
    'admin.order.returnRequest.declineNote': 'Motif du refus',
    'admin.order.returnRequest.message': 'Message du client',
    'admin.order.returnRequest.status.requested': 'En attente',
    'admin.order.returnRequest.status.accepted': 'Acceptée',
    'admin.order.returnRequest.status.declined': 'Refusée',
};
//# sourceMappingURL=fr.js.map